import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Box,
    Chip,
    useTheme,
    InputAdornment,
    IconButton,
    Tooltip,
    Fade,
    CircularProgress,
    Switch,
    FormControlLabel
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { Helmet } from 'react-helmet';

// Dane rankingowe ELO
const csvData = `Rank,Player,Rating,Games_Played,Wins,Losses,Draws,Win_Rate,Last_Game_Date,ELO_Change_Last_30_Days
1,M7_damaneks,1936.6,738,452,286,0,61.2%,2025-06-29,+61.9
2,J4kubb,1853.3,833,564,269,0,67.7%,2025-06-29,+51.5
3,Mateusz Kopec,1852.8,203,141,62,0,69.5%,2025-05-10,0.0
4,M7_Baczek,1847.8,473,293,180,0,61.9%,2025-06-29,-21.7
5,kubamadry,1846.9,1162,730,432,0,62.8%,2025-06-29,-54.3
6,Spamm3r,1846.1,500,309,191,0,61.8%,2025-06-18,+56.5
7,Leopold,1826.0,495,300,195,0,60.6%,2025-05-17,0.0
8,Terry_PL,1820.3,709,423,286,0,59.7%,2025-06-30,+73.3
9,Dimbar,1812.3,541,300,241,0,55.5%,2025-06-29,+152.0
10,Peperson,1796.2,320,214,106,0,66.9%,2025-06-19,-89.8
11,IamDearDeer,1782.7,730,456,274,0,62.5%,2025-06-30,+107.3
12,KrzL,1782.4,259,158,101,0,61.0%,2025-06-30,+165.3
13,Wojciech Klimczyk,1781.1,66,53,13,0,80.3%,2025-05-17,0.0
14,RAV92,1778.1,176,137,39,0,77.8%,2025-05-14,0.0
15,Avinster,1772.7,729,455,274,0,62.4%,2025-06-24,-101.7
16,7351921,1770.2,634,394,240,0,62.1%,2025-06-29,+36.9
17,Pterogrom,1766.4,381,226,155,0,59.3%,2025-06-30,+53.2
18,Eldek,1758.4,742,451,291,0,60.8%,2025-06-24,-16.0
19,Mullenkamp,1749.1,156,94,62,0,60.3%,2025-06-07,+73.4
20,simograj,1748.6,671,405,266,0,60.4%,2025-06-26,+107.1
21,Moluk,1730.2,440,308,132,0,70.0%,2025-06-28,+23.3
22,barczek,1727.7,145,91,54,0,62.8%,2025-05-17,0.0
23,bartoszk,1723.7,344,206,138,0,59.9%,2025-06-30,+83.2
24,FilB,1721.8,435,275,160,0,63.2%,2025-06-30,+49.9
25,MODZEL,1720.5,240,152,88,0,63.3%,2025-06-01,+74.1
26,Bartłomiej Jurczyk,1718.6,411,260,151,0,63.3%,2025-06-14,+19.2
27,Walitor,1715.9,710,433,277,0,61.0%,2025-06-29,-62.2
28,Luminos,1699.7,199,131,68,0,65.8%,2024-08-29,0.0
29,Liryq,1689.0,409,255,154,0,62.3%,2025-06-29,+75.9
30,cyndaquilka,1688.0,300,191,109,0,63.7%,2025-06-23,+58.5
31,M7_michalek_x,1687.2,690,433,257,0,62.8%,2025-06-28,-80.1
32,M7_Krzysztof_Kasak,1686.6,660,403,257,0,61.1%,2025-06-28,-89.4
33,nikon,1683.4,451,273,178,0,60.5%,2025-06-29,-2.7
34,Kowall,1677.4,330,168,162,0,50.9%,2025-06-19,+128.9
35,RafDmo,1676.1,450,265,185,0,58.9%,2025-06-29,-30.9
36,DonTigh,1673.6,110,78,32,0,70.9%,2025-06-19,+30.5
37,Medi,1669.0,269,139,130,0,51.7%,2025-06-30,+34.4
38,Wojdi,1663.6,673,401,272,0,59.6%,2025-06-28,-71.7
39,macieksik,1663.1,216,124,92,0,57.4%,2025-06-29,+25.0
40,Guzin,1657.6,598,343,255,0,57.4%,2025-06-30,-48.0
41,Cytryndor,1657.1,506,351,155,0,69.4%,2025-07-01,-0.5
42,Drakelorcana,1652.2,309,186,123,0,60.2%,2025-06-25,+91.2
43,KubaRogal,1652.2,553,342,211,0,61.8%,2025-06-19,-88.1
44,Masakratus,1651.4,353,223,130,0,63.2%,2025-06-30,-141.5
45,Ostry,1645.9,623,387,236,0,62.1%,2025-06-28,-89.6
46,69tnt69,1645.5,458,266,192,0,58.1%,2025-06-21,-112.7
47,BartoszD,1635.7,310,196,114,0,63.2%,2025-06-07,+30.8
48,Snowhisky,1633.7,52,41,11,0,78.8%,2025-06-21,+82.2
49,Bananza,1633.3,40,28,12,0,70.0%,2025-06-07,+364.8
50,hufrey,1630.4,324,176,148,0,54.3%,2025-06-18,+188.3
51,Crusty,1629.4,276,161,115,0,58.3%,2025-06-29,-43.9
52,puzzleverse,1629.2,205,132,73,0,64.4%,2025-04-10,0.0
53,EvilBunny0987,1622.9,335,191,144,0,57.0%,2025-06-28,+36.1
54,BayoJajo,1618.1,798,445,353,0,55.8%,2025-06-30,-96.3
55,ErnK,1615.0,477,266,211,0,55.8%,2025-06-26,-62.6
56,OloiBolo,1608.9,152,82,70,0,53.9%,2025-06-28,+77.3
57,Sheitene,1608.5,205,117,88,0,57.1%,2025-06-30,+257.5
58,Zaspiewaj,1608.0,488,297,191,0,60.9%,2025-06-20,-104.4
59,franulas,1603.6,80,56,24,0,70.0%,2024-04-28,0.0
60,Majkel,1601.1,431,255,176,0,59.2%,2025-06-18,+1.2
61,MarK30,1600.6,166,106,60,0,63.9%,2025-06-11,+17.4
62,Klimczur,1596.7,90,57,33,0,63.3%,2024-09-16,0.0
63,CogitoPL,1596.3,418,239,179,0,57.2%,2025-06-17,+4.3
64,Olsonik,1595.5,89,53,36,0,59.6%,2025-05-25,0.0
65,Pendzi,1593.4,611,387,224,0,63.3%,2025-06-30,-231.1
66,Litard,1589.4,409,278,131,0,68.0%,2025-05-25,0.0
67,M7_warfi,1588.9,637,349,288,0,54.8%,2025-06-29,+95.2
68,M7_stankol,1587.2,495,272,223,0,54.9%,2025-06-29,-60.4
69,Boledrag,1585.3,264,155,109,0,58.7%,2025-06-29,-81.2
70,flasz3r,1584.7,207,123,84,0,59.4%,2025-05-14,0.0
71,Greyvall,1583.2,192,97,95,0,50.5%,2025-06-17,+175.8
72,Hitorit,1580.6,581,281,300,0,48.4%,2025-06-29,+27.4
73,PawW,1578.4,182,126,56,0,69.2%,2025-06-21,-88.3
74,Ondrej_H,1575.2,92,53,39,0,57.6%,2025-05-25,0.0
75,KWB,1575.0,600,317,283,0,52.8%,2025-06-29,+117.0
76,Matiisen,1574.2,123,82,41,0,66.7%,2024-08-31,0.0
77,Zet,1570.0,537,330,207,0,61.5%,2025-06-24,+42.2
78,LeonidasM,1567.4,177,101,76,0,57.1%,2025-06-26,+54.9
79,Lukuu,1561.0,190,134,56,0,70.5%,2025-05-04,0.0
80,cloudjubei,1559.8,294,156,138,0,53.1%,2024-11-18,0.0
81,SenseMyLore,1556.9,297,150,147,0,50.5%,2025-06-28,+26.4
82,Rafał Tarnowski,1556.0,126,77,49,0,61.1%,2025-05-18,0.0
83,Gilu,1555.6,251,139,112,0,55.4%,2025-06-29,+33.4
84,LilTrader,1552.8,149,88,61,0,59.1%,2025-06-27,-72.5
85,GPL_Sowix,1552.5,228,125,103,0,54.8%,2025-06-14,+93.3
86,Tajfun,1550.0,426,253,173,0,59.4%,2025-06-14,+18.9
87,malyxksz,1548.6,377,212,165,0,56.2%,2025-06-18,-56.8
88,Demonps5,1547.7,478,269,209,0,56.3%,2025-06-12,+55.9
89,Ekierka,1542.3,190,127,63,0,66.8%,2025-06-24,-48.7
90,Adask023,1539.9,67,41,26,0,61.2%,2025-06-25,+142.1
91,Macaseczek,1539.4,170,102,68,0,60.0%,2025-04-27,0.0
92,polishvodkadrinker,1534.3,357,216,141,0,60.5%,2025-06-11,-7.1
93,coleslaw08,1534.2,444,247,197,0,55.6%,2025-06-28,+63.2
94,Badu090,1533.1,331,182,149,0,55.0%,2025-06-25,+30.4
95,Dreamymarek,1532.0,284,174,110,0,61.3%,2024-10-23,0.0
96,Exeter,1531.4,267,174,93,0,65.2%,2024-08-03,0.0
97,Trunko,1531.1,153,97,56,0,63.4%,2025-05-17,0.0
98,Zygi,1529.5,626,372,254,0,59.4%,2025-06-22,-22.0
99,Zbrojson,1529.2,161,99,62,0,61.5%,2024-09-19,0.0
100,0nceler,1528.3,62,38,24,0,61.3%,2025-06-07,+56.7
101,Gr4b4rz,1528.1,198,125,73,0,63.1%,2025-06-24,-206.7
102,Slonce,1523.9,433,234,199,0,54.0%,2025-06-18,-8.5
103,mp14,1520.1,289,153,136,0,52.9%,2025-06-24,-66.5
104,Koster,1519.3,211,121,90,0,57.3%,2025-06-07,+37.0
105,Karation,1518.8,451,237,214,0,52.5%,2025-06-29,-152.5
106,bahrynowskijakub,1513.9,335,209,126,0,62.4%,2025-06-30,-47.8
107,MichalToczek,1511.8,114,67,47,0,58.8%,2025-06-21,-86.8
108,Inazumi,1508.6,64,34,30,0,53.1%,2025-05-25,0.0
109,FaustynaPekala,1507.7,68,44,24,0,64.7%,2025-04-30,0.0
110,Despen,1506.5,340,166,174,0,48.8%,2025-06-28,+138.2
111,Igor Wesołowski,1505.9,182,110,72,0,60.4%,2025-03-01,0.0
112,y5jhk,1505.6,128,77,51,0,60.2%,2025-06-08,+32.6
113,Papafrend,1505.1,246,148,98,0,60.2%,2025-06-28,+10.8
114,Praja,1503.9,68,42,26,0,61.8%,2025-01-12,0.0
115,Pepowski,1501.7,209,117,92,0,56.0%,2024-09-14,0.0
116,ElKrystiano,1499.8,351,222,129,0,63.2%,2025-01-17,0.0
117,remmummer,1493.4,455,264,191,0,58.0%,2025-04-27,0.0
118,MiroWing,1490.9,106,64,42,0,60.4%,2025-06-18,+20.5
119,TSR_Luminator,1489.6,61,36,25,0,59.0%,2025-01-11,0.0
120,Fareneit,1488.4,77,47,30,0,61.0%,2025-01-25,0.0
121,TooDizzy,1486.8,354,176,178,0,49.7%,2025-06-25,-96.4
122,michaelius,1485.9,359,191,168,0,53.2%,2025-06-17,+27.5
123,Porg_Dameron,1485.4,116,66,50,0,56.9%,2025-06-24,+132.8
124,Loredude,1481.7,16,14,2,0,87.5%,2025-05-10,0.0
125,Bartosz Mrozinski,1472.8,733,431,302,0,58.8%,2025-06-16,+99.3
126,Runner,1472.5,398,192,206,0,48.2%,2025-06-19,+80.4
127,INK_Ompetent,1472.0,84,52,32,0,61.9%,2025-01-11,0.0
128,Wosho,1471.8,163,95,68,0,58.3%,2025-02-06,0.0
129,wojtekkow,1470.3,174,100,74,0,57.5%,2025-06-28,+7.5
130,InkBrewer_Beppo,1469.4,25,18,7,0,72.0%,2025-01-12,0.0
131,Otoczak,1469.1,382,217,165,0,56.8%,2025-06-24,+103.3
132,P4nda,1468.6,328,165,163,0,50.3%,2025-06-28,+19.6
133,Pluto,1468.2,79,46,33,0,58.2%,2025-01-18,0.0
134,TomZ1,1467.1,43,29,14,0,67.4%,2024-10-20,0.0
135,migosore,1463.8,124,70,54,0,56.5%,2025-06-18,+65.9
136,MacP4,1460.3,73,37,36,0,50.7%,2024-11-10,0.0
137,Denargon,1459.3,56,37,19,0,66.1%,2025-06-13,+35.0
138,PawB1,1457.9,136,82,54,0,60.3%,2025-06-30,-61.5
139,DashCable,1457.6,63,37,26,0,58.7%,2025-06-07,+97.6
140,malgokow,1455.7,230,124,106,0,53.9%,2025-06-28,+108.8
141,MyukuTCG,1454.1,419,247,172,0,58.9%,2025-06-16,-44.4
142,przck_Shikatzu,1453.3,136,76,60,0,55.9%,2025-06-21,+88.7
143,TCR_Sanrow,1452.2,50,31,19,0,62.0%,2025-01-12,0.0
144,Vuczko,1450.3,85,48,37,0,56.5%,2025-01-25,0.0
145,LukK13,1447.9,157,80,77,0,51.0%,2025-06-07,+18.0
146,HansToNieJa,1446.7,162,83,79,0,51.2%,2025-03-01,0.0
147,leviniuch,1445.8,90,53,37,0,58.9%,2025-05-17,0.0
148,KubaStrugarek,1443.9,266,134,132,0,50.4%,2025-06-07,+36.1
149,Buleslav,1443.7,346,171,175,0,49.4%,2025-06-28,-83.5
150,JakubNowy,1442.7,129,73,56,0,56.6%,2024-10-12,0.0
151,HansKloss,1438.5,708,381,327,0,53.8%,2025-06-19,+62.3
152,M7_Losiowaty,1437.5,532,254,278,0,47.7%,2025-06-25,-78.2
153,Mroman,1434.7,450,233,217,0,51.8%,2025-05-13,0.0
154,Hulajka,1433.2,446,203,243,0,45.5%,2025-06-08,+52.4
155,Hubson,1432.5,158,89,69,0,56.3%,2024-09-09,0.0
156,Patrollbb,1431.6,28,19,9,0,67.9%,2025-05-24,0.0
157,jank0_1,1429.8,82,45,37,0,54.9%,2025-03-30,0.0
158,Rhivaun,1427.0,56,36,20,0,64.3%,2024-10-12,0.0
159,Skaza,1425.9,373,206,167,0,55.2%,2025-07-01,-225.4
160,Nervous,1425.2,381,229,152,0,60.1%,2025-07-01,-120.2
161,JiBor,1424.5,33,21,12,0,63.6%,2024-10-12,0.0
162,Romek010,1423.6,330,190,140,0,57.6%,2025-02-08,0.0
163,Sebiq,1422.6,67,41,26,0,61.2%,2024-08-05,0.0
164,RealYogiBear,1419.7,147,73,74,0,49.7%,2025-06-22,+136.4
165,Mikicz,1416.9,230,122,108,0,53.0%,2025-06-07,+44.3
166,Nieaneta,1416.8,100,58,42,0,58.0%,2025-06-19,+37.6
167,BernardGG,1415.7,150,74,76,0,49.3%,2025-06-29,+150.3
168,Miyoshimatsuyo,1415.3,351,186,165,0,53.0%,2025-06-22,+57.5
169,Maras,1413.1,42,28,14,0,66.7%,2024-10-10,0.0
170,WINDY,1412.6,254,130,124,0,51.2%,2025-06-18,+3.9
171,Hesser,1410.3,112,58,54,0,51.8%,2025-06-28,+45.1
172,JakubJachimkowski,1409.4,38,21,17,0,55.3%,2025-05-25,0.0
173,MichalTrz,1407.1,42,25,17,0,59.5%,2025-06-16,+90.7
174,Habdasior,1406.0,34,21,13,0,61.8%,2025-03-26,0.0
175,SkladGier,1405.6,54,30,24,0,55.6%,2025-03-01,0.0
176,sas,1401.5,27,21,6,0,77.8%,2024-09-05,0.0
177,Cjack0308,1400.9,39,24,15,0,61.5%,2025-01-12,0.0
178,MC_Brauerei,1400.1,31,21,10,0,67.7%,2024-04-06,0.0
179,MicK22,1396.4,183,106,77,0,57.9%,2025-06-21,-28.5
180,Semilio,1393.9,109,63,46,0,57.8%,2025-06-06,+33.9
181,Adas1337,1390.2,141,69,72,0,48.9%,2025-07-01,+104.7
182,Rob de Haan,1388.1,31,20,11,0,64.5%,2024-04-06,0.0
183,NikoB,1387.8,140,73,67,0,52.1%,2025-05-25,0.0
184,Jakub,1386.6,173,82,91,0,47.4%,2025-06-29,+87.3
185,Rosse,1385.7,192,92,100,0,47.9%,2025-06-28,+28.6
186,A1exis,1383.4,115,64,51,0,55.7%,2025-06-19,+29.0
187,ooangelinaoo,1382.1,44,27,17,0,61.4%,2025-01-12,0.0
188,Dawid Kryński,1380.5,90,49,41,0,54.4%,2025-06-07,-37.7
189,mprajsner,1380.0,14,12,2,0,85.7%,2024-04-20,0.0
190,Defaus,1377.8,724,289,435,0,39.9%,2025-06-26,-47.5
191,CentrumGierPegaz,1377.7,369,199,170,0,53.9%,2025-06-23,+12.7
192,Vanos,1375.7,503,297,206,0,59.0%,2025-06-20,-116.9
193,Minaxo,1375.5,73,40,33,0,54.8%,2025-06-27,+9.9
194,AndrzejB,1375.1,528,254,274,0,48.1%,2025-06-09,+77.1
195,giuseppe pierandrei,1374.9,19,14,5,0,73.7%,2024-04-06,0.0
196,Biedren,1373.6,118,59,59,0,50.0%,2025-05-25,0.0
197,Łukasz Klimek,1372.1,10,10,0,0,100.0%,2024-06-29,0.0
198,Thorir,1372.0,96,43,53,0,44.8%,2025-06-05,+78.8
199,Rogu,1371.8,113,66,47,0,58.4%,2024-10-05,0.0
200,Mattsonn,1371.7,426,200,226,0,46.9%,2025-06-07,-115.6
201,rwolak,1371.4,11,10,1,0,90.9%,2025-02-01,0.0
202,Szychu,1370.0,68,38,30,0,55.9%,2024-07-28,0.0
203,IKO_Johannes0637,1368.9,21,14,7,0,66.7%,2025-01-11,0.0
204,VeLoOx,1368.3,73,39,34,0,53.4%,2025-06-21,+51.9
205,Orysz,1368.0,90,50,40,0,55.6%,2025-04-27,0.0
206,Wencus,1367.7,31,18,13,0,58.1%,2025-02-08,0.0
207,BorW1,1366.3,80,42,38,0,52.5%,2025-03-16,0.0
208,AgaB,1365.8,42,26,16,0,61.9%,2025-06-17,-35.9
209,winnmar,1365.3,22,16,6,0,72.7%,2025-04-15,0.0
210,marenty,1364.8,72,38,34,0,52.8%,2024-11-04,0.0
211,InkBrewer_Rob,1364.6,22,14,8,0,63.6%,2025-01-12,0.0
212,TiO2,1364.1,79,44,35,0,55.7%,2025-06-28,-33.7
213,Grzegorz Kowalski,1364.0,37,23,14,0,62.2%,2024-08-31,0.0
214,Little_Skrash,1363.6,327,135,192,0,41.3%,2025-06-18,+18.1
215,Piro272,1361.7,188,98,90,0,52.1%,2025-05-25,0.0
216,Grizz1y,1361.5,63,34,29,0,54.0%,2025-01-25,0.0
217,BloodDice,1360.2,405,228,177,0,56.3%,2025-06-09,+21.0
218,avlav,1360.2,308,148,160,0,48.1%,2025-07-01,+162.3
219,Szymon1908,1359.9,266,135,131,0,50.8%,2025-06-16,-86.2
220,Ayesha,1359.0,134,80,54,0,59.7%,2024-10-26,0.0
221,Zmyslony,1358.6,104,49,55,0,47.1%,2025-05-20,0.0
222,TCR_Dextr0niC,1356.5,20,13,7,0,65.0%,2025-01-11,0.0
223,JakubM,1355.8,202,89,113,0,44.1%,2025-06-26,+140.3
224,wodnik,1355.4,468,231,237,0,49.4%,2025-06-26,-7.1
225,Yardem,1355.3,152,72,80,0,47.4%,2025-06-28,-72.5
226,MC_bratwurst,1355.0,34,20,14,0,58.8%,2025-01-11,0.0
227,Speci,1354.7,28,18,10,0,64.3%,2024-04-06,0.0
228,Jey,1352.0,42,25,17,0,59.5%,2025-01-12,0.0
229,Dayrisel,1349.3,238,103,135,0,43.3%,2025-06-29,+40.1
230,Gustlik,1349.1,115,57,58,0,49.6%,2025-06-08,+10.0
231,MKT_SkelliBoi,1348.7,38,22,16,0,57.9%,2024-08-31,0.0
232,Anubian,1348.2,302,165,137,0,54.6%,2025-05-11,0.0
233,Kunikosia,1348.0,560,288,272,0,51.4%,2025-06-20,-153.6
234,Keul,1344.0,24,16,8,0,66.7%,2024-04-06,0.0
235,Bartekkawa8,1343.4,189,81,108,0,42.9%,2025-05-17,0.0
236,Mayxs,1343.1,81,40,41,0,49.4%,2025-06-29,+187.4
237,Lukas Kaupa,1341.5,24,16,8,0,66.7%,2024-04-06,0.0
238,Krains,1340.4,57,31,26,0,54.4%,2025-04-27,0.0
239,TSR_Erebos,1340.1,22,15,7,0,68.2%,2024-04-06,0.0
240,virtualz15,1338.4,18,13,5,0,72.2%,2024-07-17,0.0
241,KryS1,1338.2,15,11,4,0,73.3%,2024-06-14,0.0
242,WiniT,1338.1,95,46,49,0,48.4%,2025-06-07,+86.5
243,Jacek Korpikiewicz,1337.6,30,18,12,0,60.0%,2024-04-27,0.0
244,Skolsik,1335.5,20,14,6,0,70.0%,2024-07-17,0.0
245,Tobik,1335.3,199,102,97,0,51.3%,2025-05-04,0.0
246,LittleRedPanda,1334.9,184,76,108,0,41.3%,2025-06-27,+315.6
247,MacS4,1333.1,21,15,6,0,71.4%,2024-07-13,0.0
248,Szumek,1331.8,179,78,101,0,43.6%,2025-06-26,+18.4
249,DomU,1330.8,205,121,84,0,59.0%,2025-06-26,-52.9
250,mirash,1328.8,85,46,39,0,54.1%,2025-05-17,0.0
251,Dave95,1328.1,56,30,26,0,53.6%,2025-06-02,+4.2
252,Pawrti,1326.8,333,198,135,0,59.5%,2024-09-22,0.0
253,MrPink195,1326.0,9,8,1,0,88.9%,2024-06-19,0.0
254,LauH,1323.4,34,18,16,0,52.9%,2025-01-11,0.0
255,xjoy,1322.3,31,19,12,0,61.3%,2025-03-19,0.0
256,BrudnyChleb,1321.7,28,16,12,0,57.1%,2025-05-25,0.0
257,Szkic,1320.3,117,60,57,0,51.3%,2025-06-21,-18.9
258,TH44,1319.3,34,20,14,0,58.8%,2025-02-05,0.0
259,Alzur,1317.7,11,9,2,0,81.8%,2024-06-02,0.0
260,TCR_DeepBlue,1316.9,38,21,17,0,55.3%,2024-08-31,0.0
261,TCR_JeffDerGraue,1316.9,35,21,14,0,60.0%,2024-08-31,0.0
262,JaQper,1315.8,102,47,55,0,46.1%,2025-01-28,0.0
263,Labajka,1314.3,66,36,30,0,54.5%,2025-05-25,0.0
264,Meterion,1313.8,96,44,52,0,45.8%,2025-05-25,0.0
265,bartii,1313.6,28,17,11,0,60.7%,2024-07-16,0.0
266,Juluja,1312.7,93,36,57,0,38.7%,2025-06-05,+34.6
267,TCR_Tim,1311.3,43,24,19,0,55.8%,2025-01-12,0.0
268,Robert Szura,1310.5,79,43,36,0,54.4%,2025-06-19,-12.7
269,PigletXL,1309.0,90,41,49,0,45.6%,2025-06-30,+76.9
270,Silv4n,1308.8,14,8,6,0,57.1%,2025-03-01,0.0
271,PioJ,1308.2,254,120,134,0,47.2%,2025-06-21,-34.3
272,Morp77,1308.0,6,6,0,0,100.0%,2025-02-03,0.0
273,osioo,1306.9,50,26,24,0,52.0%,2025-06-10,-8.1
274,Michlithr,1306.5,69,35,34,0,50.7%,2025-06-12,+73.8
275,Makkinez,1306.4,19,13,6,0,68.4%,2024-08-17,0.0
276,TRIBIXON,1302.5,31,18,13,0,58.1%,2024-09-27,0.0
277,Limek,1301.7,30,17,13,0,56.7%,2025-06-21,+155.2
278,SebS4,1301.4,152,82,70,0,53.9%,2025-03-20,0.0
279,JacK19,1300.5,11,8,3,0,72.7%,2024-03-20,0.0
280,Hinvidia,1298.0,25,15,10,0,60.0%,2024-04-06,0.0
281,Olawa,1297.7,205,96,109,0,46.8%,2025-06-29,-19.5
282,Rolo,1297.7,177,95,82,0,53.7%,2024-09-12,0.0
283,Sendivius,1297.4,20,13,7,0,65.0%,2024-08-07,0.0
284,tirexPOR,1296.3,29,14,15,0,48.3%,2025-05-25,0.0
285,Winiak,1296.2,39,21,18,0,53.8%,2025-06-19,+53.4
286,Conquistador97,1295.9,22,13,9,0,59.1%,2024-04-06,0.0
287,MicK29,1295.5,7,6,1,0,85.7%,2025-05-04,0.0
288,bestiazpoznania,1293.4,217,97,120,0,44.7%,2025-06-28,+74.7
289,Birtek,1292.0,13,9,4,0,69.2%,2024-03-29,0.0
290,Esus,1291.5,374,202,172,0,54.0%,2025-04-18,0.0
291,Stichrockstar,1291.2,241,102,139,0,42.3%,2025-06-26,+95.2
292,Harald158,1290.6,25,15,10,0,60.0%,2024-04-06,0.0
293,mstokowski,1290.2,40,22,18,0,55.0%,2024-04-27,0.0
294,Vivaz,1290.0,21,13,8,0,61.9%,2024-04-06,0.0
295,Bizzon,1289.0,80,46,34,0,57.5%,2024-07-16,0.0
296,mikfil,1288.6,31,17,14,0,54.8%,2024-09-03,0.0
297,Martin_,1288.1,19,11,8,0,57.9%,2025-06-07,+88.1
298,KonradDominiczak,1288.0,105,46,59,0,43.8%,2025-05-18,0.0
299,MKT_ArcticEden,1287.8,28,14,14,0,50.0%,2024-08-31,0.0
300,Lukas_99,1287.6,19,12,7,0,63.2%,2024-04-06,0.0
301,Maciej Pukrop,1286.8,22,13,9,0,59.1%,2024-03-02,0.0
302,Luq1989,1286.6,409,171,238,0,41.8%,2025-06-19,-64.6
303,JanR6,1286.3,175,79,96,0,45.1%,2025-02-08,0.0
304,ader118,1284.0,89,47,42,0,52.8%,2024-11-19,0.0
305,SamR1,1283.8,20,12,8,0,60.0%,2024-04-06,0.0
306,Cantharis,1283.8,7,6,1,0,85.7%,2024-11-07,0.0
307,Bartosz (pron. BAR-tosh) M,1283.3,13,8,5,0,61.5%,2024-07-13,0.0
308,ForestCamp,1282.7,14,7,7,0,50.0%,2025-06-07,+82.7
309,Mavelovent,1282.6,4,4,0,0,100.0%,2024-09-13,0.0
310,iCube,1282.3,8,6,2,0,75.0%,2024-08-09,0.0
311,Skiffy,1281.9,6,5,1,0,83.3%,2024-11-13,0.0
312,JackThePanda,1281.9,38,21,17,0,55.3%,2024-03-24,0.0
313,Szavi,1281.5,12,8,4,0,66.7%,2024-10-02,0.0
314,NinZ,1280.7,22,13,9,0,59.1%,2024-04-06,0.0
315,MatO,1280.6,6,5,1,0,83.3%,2025-01-17,0.0
316,robko,1280.4,17,10,7,0,58.8%,2024-04-06,0.0
317,pawelkak,1279.9,24,14,10,0,58.3%,2024-04-06,0.0
318,Rrroky,1279.0,31,15,16,0,48.4%,2025-05-25,0.0
319,Voj4k,1278.6,166,81,85,0,48.8%,2025-06-17,-46.1
320,EliminatoR,1278.3,331,152,179,0,45.9%,2025-04-22,0.0
321,Duzy,1277.9,10,7,3,0,70.0%,2024-07-17,0.0
322,EKR136692,1277.8,6,5,1,0,83.3%,2024-10-23,0.0
323,Stasio,1277.5,160,69,91,0,43.1%,2025-06-24,+63.3
324,OtterZockerTTV,1276.9,22,13,9,0,59.1%,2024-04-06,0.0
325,Frogger86,1276.5,43,24,19,0,55.8%,2024-10-12,0.0
326,Dnaiel,1275.9,8,6,2,0,75.0%,2024-07-17,0.0
327,Rayek,1275.1,69,41,28,0,59.4%,2025-05-24,0.0
328,EastGermanJuggernaut,1273.3,24,14,10,0,58.3%,2024-04-06,0.0
329,VarezQ,1273.3,4,4,0,0,100.0%,2025-04-12,0.0
330,Kesannn,1273.2,157,64,93,0,40.8%,2025-06-28,+59.4
331,Circus,1272.5,18,11,7,0,61.1%,2024-04-06,0.0
332,ccancerr85,1272.3,14,9,5,0,64.3%,2025-05-24,0.0
333,IKO_Spike,1272.0,20,12,8,0,60.0%,2024-04-06,0.0
334,W_Baker,1271.6,205,86,119,0,42.0%,2025-03-28,0.0
335,GearDeer,1270.7,4,4,0,0,100.0%,2025-03-07,0.0
336,Qbencjusz,1270.5,130,59,71,0,45.4%,2024-08-27,0.0
337,ALY049560,1270.4,6,5,1,0,83.3%,2025-03-22,0.0
338,Keane Minahan,1270.0,18,11,7,0,61.1%,2024-04-06,0.0
339,Forcas,1270.0,8,6,2,0,75.0%,2025-03-07,0.0
340,Cwynareiro,1269.0,20,12,8,0,60.0%,2024-07-17,0.0
341,Juufi,1269.0,47,25,22,0,53.2%,2024-08-31,0.0
342,Shufter,1268.5,270,103,167,0,38.1%,2025-05-06,0.0
343,Mikemx5,1267.9,65,30,35,0,46.2%,2025-05-17,0.0
344,Pelek,1267.6,60,30,30,0,50.0%,2025-05-20,0.0
345,PiekielneSandaly,1266.8,8,5,3,0,62.5%,2024-09-11,0.0
346,Aran,1266.2,29,16,13,0,55.2%,2024-03-19,0.0
347,matkop,1265.9,28,15,13,0,53.6%,2025-04-27,0.0
348,Iscario,1265.4,145,68,77,0,46.9%,2025-02-24,0.0
349,AntW12,1264.9,75,41,34,0,54.7%,2025-06-14,+5.9
350,TCR_endyucation,1264.7,14,8,6,0,57.1%,2024-08-31,0.0
351,AntW14,1264.2,63,35,28,0,55.6%,2025-02-01,0.0
352,zuzvnnv,1264.1,130,59,71,0,45.4%,2024-11-05,0.0
353,Ganczar,1263.6,27,15,12,0,55.6%,2025-05-25,0.0
354,PD_Nachtgeist,1263.5,21,12,9,0,57.1%,2024-04-06,0.0
355,Mollerz,1263.3,48,26,22,0,54.2%,2025-01-11,0.0
356,Martin Pelíšek,1262.9,48,24,24,0,50.0%,2025-01-25,0.0
357,burb,1262.9,29,17,12,0,58.6%,2024-08-22,0.0
358,MarekBogiel,1262.8,18,10,8,0,55.6%,2024-09-28,0.0
359,obiwan1289,1262.4,17,10,7,0,58.8%,2024-09-28,0.0
360,UrbiEinser,1261.5,17,10,7,0,58.8%,2024-07-27,0.0
361,KrolJulian,1259.8,291,155,136,0,53.3%,2025-06-23,+17.5
362,AdrianOr,1258.9,18,11,7,0,61.1%,2024-07-17,0.0
363,maciej janik,1258.1,37,20,17,0,54.1%,2024-04-27,0.0
364,Szymon Rząd,1257.8,143,61,82,0,42.7%,2025-06-22,+130.3
365,Wojciechov,1256.5,36,20,16,0,55.6%,2024-07-11,0.0
366,Rhemx,1256.0,19,11,8,0,57.9%,2024-04-06,0.0
367,Olivia99,1255.9,22,13,9,0,59.1%,2024-09-20,0.0
368,PandaMian,1255.8,12,6,6,0,50.0%,2025-02-08,0.0
369,Eroth,1255.3,19,11,8,0,57.9%,2024-07-17,0.0
370,Abrakadabra,1255.3,19,11,8,0,57.9%,2024-06-20,0.0
371,Kamil Kulczyński,1255.2,33,17,16,0,51.5%,2024-04-27,0.0
372,Lukasz,1254.5,7,5,2,0,71.4%,2024-08-28,0.0
373,kack1,1254.4,13,8,5,0,61.5%,2024-08-22,0.0
374,HazeG,1254.0,9,6,3,0,66.7%,2024-06-19,0.0
375,kwojciak,1254.0,17,10,7,0,58.8%,2024-04-20,0.0
376,Maciej,1254.0,7,5,2,0,71.4%,2025-02-03,0.0
377,Darkjedi,1254.0,5,4,1,0,80.0%,2025-04-16,0.0
378,magk1,1253.7,7,5,2,0,71.4%,2024-08-08,0.0
379,agusia,1253.7,76,36,40,0,47.4%,2025-05-17,0.0
380,IKO_Sayman,1253.6,27,15,12,0,55.6%,2024-04-06,0.0
381,Shirownik,1253.3,9,6,3,0,66.7%,2024-07-17,0.0
382,pandzister,1253.0,470,198,272,0,42.1%,2025-06-28,-50.7
383,Kuba Tambor,1252.6,17,10,7,0,58.8%,2024-04-06,0.0
384,CUN185241,1252.0,11,7,4,0,63.6%,2025-05-22,0.0
385,Northern,1249.8,14,7,7,0,50.0%,2025-06-21,+49.8
386,KarolKarol,1249.7,14,7,7,0,50.0%,2025-02-17,0.0
387,Xanet,1249.6,43,22,21,0,51.2%,2024-10-12,0.0
388,PaLF44,1249.5,34,20,14,0,58.8%,2025-05-24,0.0
389,mkmmpi,1249.0,6,4,2,0,66.7%,2025-02-12,0.0
390,Zwierzaaak,1248.2,7,5,2,0,71.4%,2025-04-12,0.0
391,KountessKale,1248.1,8,5,3,0,62.5%,2025-02-05,0.0
392,koweras,1247.8,69,31,38,0,44.9%,2025-06-17,-28.9
393,RQB660131,1247.7,7,4,3,0,57.1%,2024-09-15,0.0
394,buonaserrrra,1247.3,18,10,8,0,55.6%,2024-04-06,0.0
395,LCN_Muffin,1247.2,18,10,8,0,55.6%,2024-04-06,0.0
396,simplywojtek,1246.2,44,22,22,0,50.0%,2024-08-03,0.0
397,ErykBartnik,1246.0,26,14,12,0,53.8%,2024-12-22,0.0
398,Szalonykogut1221,1245.9,31,16,15,0,51.6%,2025-06-07,-15.0
399,michaek,1245.1,389,188,201,0,48.3%,2025-06-16,+61.0
400,FatRat,1245.0,130,60,70,0,46.2%,2025-06-19,-10.6
401,Gamepsychologe,1244.7,20,11,9,0,55.0%,2024-04-06,0.0
402,Tombo,1244.5,20,11,9,0,55.0%,2024-07-17,0.0
403,Mariusz,1243.0,74,35,39,0,47.3%,2025-06-19,-39.7
404,DomDomDom16,1241.8,560,236,324,0,42.1%,2025-06-16,-27.9
405,przck_Machu,1241.3,125,58,67,0,46.4%,2025-06-07,-24.6
406,Kacperzu,1241.0,35,14,21,0,40.0%,2025-05-25,0.0
407,ZielonyMis,1240.9,33,16,17,0,48.5%,2024-08-06,0.0
408,Szabla149,1240.9,8,5,3,0,62.5%,2025-03-07,0.0
409,rysiekkow,1240.8,59,28,31,0,47.5%,2025-05-24,0.0
410,Keemiko,1240.6,4,3,1,0,75.0%,2025-04-12,0.0
411,Anita15600,1240.2,110,60,50,0,54.5%,2025-04-03,0.0
412,Kixamx,1239.3,4,3,1,0,75.0%,2025-04-12,0.0
413,Lusia,1238.8,4,3,1,0,75.0%,2024-09-28,0.0
414,HarlanSweete,1238.5,20,11,9,0,55.0%,2024-04-06,0.0
415,Lutor,1238.4,51,24,27,0,47.1%,2025-05-10,0.0
416,MKT_fabjos,1238.2,18,10,8,0,55.6%,2024-04-06,0.0
417,RaffaelloWillow,1237.7,8,5,3,0,62.5%,2024-07-06,0.0
418,exeq,1237.5,31,14,17,0,45.2%,2025-06-20,-43.6
419,Barti,1237.2,12,7,5,0,58.3%,2024-04-28,0.0
420,SamO,1237.0,18,10,8,0,55.6%,2024-04-06,0.0
421,Hakis,1236.7,4,3,1,0,75.0%,2025-03-07,0.0
422,AlghaarLukaszL,1236.6,38,22,16,0,57.9%,2025-04-09,0.0
423,Winya,1236.6,8,5,3,0,62.5%,2025-04-12,0.0
424,Haponek,1236.3,6,4,2,0,66.7%,2024-08-08,0.0
425,Karolaaa195,1236.2,8,5,3,0,62.5%,2024-06-19,0.0
426,GreenGecko,1236.1,57,28,29,0,49.1%,2024-12-09,0.0
427,arcmage,1236.0,4,3,1,0,75.0%,2024-12-14,0.0
428,NFist,1236.0,4,3,1,0,75.0%,2024-12-14,0.0
429,Klaudyna,1236.0,4,3,1,0,75.0%,2025-04-12,0.0
430,suhy98,1236.0,4,3,1,0,75.0%,2024-12-14,0.0
431,Phaereg,1236.0,20,11,9,0,55.0%,2024-04-06,0.0
432,Kaopej,1236.0,4,3,1,0,75.0%,2025-03-07,0.0
433,Sora128,1236.0,6,4,2,0,66.7%,2024-07-13,0.0
434,Skobi,1236.0,10,6,4,0,60.0%,2024-02-21,0.0
435,Emi,1236.0,2,2,0,0,100.0%,2024-04-29,0.0
436,MKT_luettii,1236.0,18,10,8,0,55.6%,2024-04-06,0.0
437,michaszek,1236.0,4,3,1,0,75.0%,2024-12-14,0.0
438,GranitForsant,1235.8,125,54,71,0,43.2%,2025-06-19,+47.7
439,4m8,1235.6,15,8,7,0,53.3%,2024-06-22,0.0
440,InkBrewer_GeMo,1235.6,22,10,12,0,45.5%,2025-01-12,0.0
441,Trzcinus,1235.2,4,3,1,0,75.0%,2025-03-07,0.0
442,MiMikaa,1235.2,4,3,1,0,75.0%,2025-03-07,0.0
443,Gmuru,1234.4,4,3,1,0,75.0%,2024-12-14,0.0
444,Piotr Kolebacz,1234.3,26,14,12,0,53.8%,2024-04-06,0.0
445,Forcasowa,1234.0,8,5,3,0,62.5%,2025-03-07,0.0
446,MarM96,1233.5,14,8,6,0,57.1%,2024-08-28,0.0
447,Herq,1232.6,439,250,189,0,56.9%,2025-04-14,0.0
448,BIM034706,1232.6,10,6,4,0,60.0%,2024-11-22,0.0
449,agentx93,1232.3,66,29,37,0,43.9%,2025-06-28,+15.5
450,AronTheGoodboy,1232.0,10,5,5,0,50.0%,2024-07-13,0.0
451,AlexTa,1231.3,8,5,3,0,62.5%,2024-07-08,0.0
452,spooderman2115,1231.2,156,71,85,0,45.5%,2025-06-23,+3.5
453,MolC,1229.2,53,24,29,0,45.3%,2025-06-07,-14.0
454,gluter,1228.9,365,216,149,0,59.2%,2025-06-29,-181.1
455,przck_stasmach,1228.8,86,41,45,0,47.7%,2025-06-07,+14.0
456,marokin,1227.3,246,117,129,0,47.6%,2025-06-21,-75.4
457,Kulis,1226.7,14,8,6,0,57.1%,2025-03-22,0.0
458,AgaE,1226.6,84,41,43,0,48.8%,2025-06-30,-61.6
459,Mydel,1226.0,8,4,4,0,50.0%,2025-04-01,0.0
460,helisa,1225.7,113,51,62,0,45.1%,2025-06-07,-32.6
461,SierszulskiM,1225.5,33,16,17,0,48.5%,2024-09-16,0.0
462,Pokes,1224.3,44,21,23,0,47.7%,2025-06-08,+47.1
463,Jan Moy,1223.5,23,12,11,0,52.2%,2024-04-06,0.0
464,MarkoPL,1223.5,157,72,85,0,45.9%,2025-05-18,0.0
465,Duck_King,1223.4,7,4,3,0,57.1%,2024-05-27,0.0
466,Mattia Vignudelli,1222.9,21,11,10,0,52.4%,2024-04-06,0.0
467,skyr02,1222.7,8,4,4,0,50.0%,2025-04-25,0.0
468,Galareta,1222.2,23,11,12,0,47.8%,2025-01-21,0.0
469,OlafMajster,1221.9,12,6,6,0,50.0%,2025-04-27,0.0
470,mateuszgandor,1221.8,36,18,18,0,50.0%,2024-12-21,0.0
471,HNE251848,1221.6,9,5,4,0,55.6%,2024-08-07,0.0
472,Filip Ociepka,1221.0,11,6,5,0,54.5%,2024-04-23,0.0
473,MaxM23,1220.4,25,12,13,0,48.0%,2025-03-05,0.0
474,Zorgon,1219.8,285,126,159,0,44.2%,2025-06-25,-14.6
475,Mateusz,1219.7,35,17,18,0,48.6%,2024-06-26,0.0
476,Paweł Kwiecień,1219.3,34,15,19,0,44.1%,2025-02-01,0.0
477,czarny71,1218.7,9,5,4,0,55.6%,2024-07-17,0.0
478,MKT_SailorGuardian,1218.5,24,11,13,0,45.8%,2024-08-31,0.0
479,Muzzler,1218.0,7,4,3,0,57.1%,2024-04-30,0.0
480,Hycu,1218.0,9,5,4,0,55.6%,2024-07-17,0.0
481,PD_Bennet,1218.0,21,11,10,0,52.4%,2024-04-06,0.0
482,Olgierdo,1218.0,7,4,3,0,57.1%,2025-02-03,0.0
483,Pulver,1218.0,21,11,10,0,52.4%,2024-04-06,0.0
484,pioma10,1218.0,5,3,2,0,60.0%,2025-04-16,0.0
485,ezoteryczna,1218.0,11,6,5,0,54.5%,2024-04-20,0.0
486,ADAM2001,1217.7,73,33,40,0,45.2%,2025-05-14,0.0
487,Iza2206,1217.6,42,18,24,0,42.9%,2025-06-16,+185.2
488,Damian Drozdowski,1217.2,8,5,3,0,62.5%,2025-06-04,+17.2
489,Imbryczek,1217.1,7,4,3,0,57.1%,2024-04-05,0.0
490,panbumbum,1217.0,7,3,4,0,42.9%,2024-09-30,0.0
491,KaptainBPoznan,1216.9,288,146,142,0,50.7%,2025-06-29,+38.4
492,Illumibarti,1216.4,156,71,85,0,45.5%,2024-09-09,0.0
493,Maruin,1216.3,14,7,7,0,50.0%,2024-07-27,0.0
494,Inv4sive,1216.0,25,13,12,0,52.0%,2024-04-06,0.0
495,Sebar,1215.9,36,19,17,0,52.8%,2024-09-12,0.0
496,Boju,1215.9,5,3,2,0,60.0%,2024-07-06,0.0
497,SzyZ,1215.9,8,4,4,0,50.0%,2025-03-18,0.0
498,DoitsuKoitsu,1214.8,21,11,10,0,52.4%,2024-04-06,0.0
499,MC_G_able,1214.3,21,11,10,0,52.4%,2024-04-06,0.0
500,iSunny1011,1214.3,19,10,9,0,52.6%,2024-04-06,0.0
501,ZELOisBack,1213.3,21,11,10,0,52.4%,2024-04-06,0.0
502,Ignacy2015,1213.3,22,11,11,0,50.0%,2024-05-10,0.0
503,Alphos,1213.2,19,10,9,0,52.6%,2024-04-06,0.0
504,chelcho73,1212.3,28,15,13,0,53.6%,2025-02-19,0.0
505,xMaZzzI,1211.8,14,5,9,0,35.7%,2024-12-21,0.0
506,malinovvaa,1211.7,7,3,4,0,42.9%,2024-09-21,0.0
507,Rymek,1211.4,15,8,7,0,53.3%,2024-03-06,0.0
508,eXisst,1211.4,184,80,104,0,43.5%,2025-06-12,+0.4
509,BartLib,1211.3,23,12,11,0,52.2%,2024-07-28,0.0
510,TrueMoomin,1210.2,7,4,3,0,57.1%,2024-05-31,0.0
511,FoltaF,1210.0,63,32,31,0,50.8%,2024-10-26,0.0
512,Tajun,1209.8,20,10,10,0,50.0%,2024-04-06,0.0
513,JPK,1209.5,20,10,10,0,50.0%,2024-04-06,0.0
514,jacacaca,1209.5,98,48,50,0,49.0%,2025-06-07,-7.5
515,Visargy,1209.4,24,11,13,0,45.8%,2025-06-07,-37.0
516,KruszynaAJ,1209.1,291,136,155,0,46.7%,2025-06-16,-8.5
517,K0di,1209.1,45,21,24,0,46.7%,2025-06-30,-13.5
518,DobT,1209.0,110,53,57,0,48.2%,2025-06-12,+22.3
519,domex,1208.8,72,29,43,0,40.3%,2025-05-07,0.0
520,brzezik919,1208.7,53,22,31,0,41.5%,2024-10-12,0.0
521,NineDragons,1208.6,7,4,3,0,57.1%,2025-04-02,0.0
522,Zwolin,1208.1,51,22,29,0,43.1%,2025-05-24,0.0
523,Kasjanito,1208.0,8,4,4,0,50.0%,2025-02-03,0.0
524,CVH182786,1207.6,4,2,2,0,50.0%,2025-02-14,0.0
525,Bober,1207.0,8,4,4,0,50.0%,2024-07-20,0.0
526,DomAaa,1206.1,4,2,2,0,50.0%,2024-10-27,0.0
527,MatejQ,1206.0,4,2,2,0,50.0%,2024-05-16,0.0
528,DanteDaKid,1205.6,183,90,93,0,49.2%,2025-02-01,0.0
529,Chrapek,1205.6,285,140,145,0,49.1%,2025-06-07,+9.2
530,Drizzt114,1205.4,4,2,2,0,50.0%,2025-05-08,0.0
531,Zoria,1205.2,20,10,10,0,50.0%,2024-04-06,0.0
532,PTCG_analiza,1204.6,12,5,7,0,41.7%,2025-02-03,0.0
533,Poohatka,1204.5,9,5,4,0,55.6%,2024-09-28,0.0
534,Mateusz_D,1204.5,262,117,145,0,44.7%,2025-06-10,+82.7
535,Kream45,1204.2,4,2,2,0,50.0%,2024-09-28,0.0
536,KVF482334,1204.1,8,4,4,0,50.0%,2024-08-17,0.0
537,pk1,1203.4,8,4,4,0,50.0%,2024-08-01,0.0
538,TejAspen,1203.3,4,2,2,0,50.0%,2025-04-12,0.0
539,MonsterUltra,1203.3,12,6,6,0,50.0%,2024-04-28,0.0
540,KrzywyJordan,1203.0,8,4,4,0,50.0%,2024-08-11,0.0
541,lesartto,1203.0,241,114,127,0,47.3%,2025-06-16,-59.3
542,Voytech,1202.8,4,2,2,0,50.0%,2024-03-28,0.0
543,Vansen,1202.8,4,2,2,0,50.0%,2024-09-28,0.0
544,CRONX,1202.6,10,5,5,0,50.0%,2024-10-09,0.0
545,DawS4,1202.4,6,3,3,0,50.0%,2024-07-02,0.0
546,elkaczuchen,1202.4,4,2,2,0,50.0%,2024-12-30,0.0
547,JacD40,1201.7,7,3,4,0,42.9%,2024-09-01,0.0
548,Ogramto,1201.7,53,27,26,0,50.9%,2025-05-17,0.0
549,gobei,1201.6,6,3,3,0,50.0%,2024-09-21,0.0
550,ESV168759,1201.6,6,3,3,0,50.0%,2024-09-21,0.0
551,Avengar,1201.2,13,6,7,0,46.2%,2024-04-28,0.0
552,Niar,1201.0,16,8,8,0,50.0%,2024-04-06,0.0
553,Kacper,1200.7,4,2,2,0,50.0%,2025-03-07,0.0
554,Prokon,1200.7,4,2,2,0,50.0%,2025-03-07,0.0
555,Rikhardur Einarsson,1200.5,17,8,9,0,47.1%,2024-04-06,0.0
556,AleM4,1200.2,22,11,11,0,50.0%,2024-04-06,0.0
557,RobD17,1200.2,14,7,7,0,50.0%,2025-01-11,0.0
558,Remik1996,1200.0,517,205,312,0,39.7%,2025-06-23,+97.3
559,Kasiatarzynkaa,1200.0,4,2,2,0,50.0%,2024-12-14,0.0
560,ADI013645,1200.0,8,4,4,0,50.0%,2024-09-21,0.0
561,Trepiok,1200.0,4,2,2,0,50.0%,2024-12-14,0.0
562,Mikk4a,1200.0,4,2,2,0,50.0%,2025-04-12,0.0
563,AleT28,1200.0,4,2,2,0,50.0%,2024-06-21,0.0
564,whatanxx,1200.0,4,2,2,0,50.0%,2025-03-07,0.0
565,KingLoczek,1200.0,4,2,2,0,50.0%,2025-03-07,0.0
566,ToshikoYasu,1200.0,4,2,2,0,50.0%,2025-03-07,0.0
567,MagicCafe,1200.0,10,5,5,0,50.0%,2024-04-20,0.0
568,Patryk_K,1200.0,8,4,4,0,50.0%,2025-04-16,0.0
569,Vulpirion,1200.0,4,2,2,0,50.0%,2024-12-14,0.0
570,BartekGoworek,1200.0,22,11,11,0,50.0%,2024-04-06,0.0
571,xRanshu,1200.0,4,2,2,0,50.0%,2024-12-14,0.0
572,toxickas,1200.0,4,2,2,0,50.0%,2024-12-14,0.0
573,TomL9,1200.0,4,2,2,0,50.0%,2024-07-06,0.0
574,matib,1199.7,26,11,15,0,42.3%,2024-12-17,0.0
575,Izdator24,1199.2,20,10,10,0,50.0%,2024-11-13,0.0
576,Tiger19815,1199.0,290,158,132,0,54.5%,2025-06-07,-86.9
577,KnifeMD,1198.7,22,11,11,0,50.0%,2025-03-16,0.0
578,JaSzpital,1198.7,4,2,2,0,50.0%,2025-03-07,0.0
579,NorK,1198.7,6,3,3,0,50.0%,2024-06-14,0.0
580,UVE89,1198.7,174,80,94,0,46.0%,2025-06-08,-44.8
581,SOWATCG,1198.1,4,2,2,0,50.0%,2025-04-12,0.0
582,JacobTCG,1198.1,4,2,2,0,50.0%,2024-03-28,0.0
583,tznd,1197.6,14,6,8,0,42.9%,2025-01-11,0.0
584,LilaDas,1197.4,247,105,142,0,42.5%,2025-06-10,+12.5
585,tomt6,1197.2,12,6,6,0,50.0%,2024-08-08,0.0
586,wlodzia,1197.0,10,5,5,0,50.0%,2024-08-11,0.0
587,ukB1,1196.5,4,2,2,0,50.0%,2024-10-30,0.0
588,Viacheslav Zakurenko,1196.3,4,2,2,0,50.0%,2024-04-16,0.0
589,RakaNishoo,1196.0,14,8,6,0,57.1%,2024-07-03,0.0
590,remixon,1195.7,10,4,6,0,40.0%,2024-08-29,0.0
591,CravenDimitrof,1195.5,265,116,149,0,43.8%,2025-06-24,-33.3
592,Johnny41,1195.1,8,4,4,0,50.0%,2025-01-31,0.0
593,ToSLU,1194.5,72,30,42,0,41.7%,2025-06-30,+53.3
594,ly,1194.3,8,4,4,0,50.0%,2024-07-13,0.0
595,TCR_Aleister,1193.6,60,29,31,0,48.3%,2025-01-12,0.0
596,Temamite,1193.6,34,15,19,0,44.1%,2025-03-01,0.0
597,Tadori,1192.9,2,1,1,0,50.0%,2025-06-28,-7.1
598,WikS,1192.3,18,9,9,0,50.0%,2024-07-13,0.0
599,Bjornson,1192.2,79,40,39,0,50.6%,2024-07-23,0.0
600,BarP3,1191.5,15,7,8,0,46.7%,2025-03-20,0.0
601,p4ziu22,1190.8,52,23,29,0,44.2%,2025-05-18,0.0
602,gunshop,1190.3,18,9,9,0,50.0%,2024-10-06,0.0
603,KVZ389020,1190.0,5,2,3,0,40.0%,2025-03-26,0.0
604,rafalsky,1189.9,11,5,6,0,45.5%,2025-01-11,0.0
605,Spocoh,1189.4,14,7,7,0,50.0%,2024-06-12,0.0
606,Mr_Dislike,1188.4,21,10,11,0,47.6%,2024-04-06,0.0
607,Armature,1188.1,19,9,10,0,47.4%,2024-04-06,0.0
608,Alexandra,1187.6,50,24,26,0,48.0%,2025-03-18,0.0
609,Ptaku,1187.3,10,4,6,0,40.0%,2025-05-11,0.0
610,Bazan,1187.1,2,0,2,0,0.0%,2025-02-13,0.0
611,Artur Pietruszka,1186.5,6,2,4,0,33.3%,2025-03-05,0.0
612,MachtderTinte,1186.3,14,6,8,0,42.9%,2025-01-11,0.0
613,Lupiezca,1186.2,3,1,2,0,33.3%,2024-09-28,0.0
614,Siruthial,1186.1,10,5,5,0,50.0%,2024-09-10,0.0
615,Igula,1185.8,13,6,7,0,46.2%,2024-04-27,0.0
616,Wintrow,1185.6,6,2,4,0,33.3%,2024-12-09,0.0
617,Filip Skórnicki,1185.3,9,3,6,0,33.3%,2025-05-17,0.0
618,JulW9,1185.0,6,2,4,0,33.3%,2025-01-24,0.0
619,Szymon Wiaderny,1184.4,7,3,4,0,42.9%,2024-07-02,0.0
620,Weles94,1184.2,104,54,50,0,51.9%,2025-06-25,+25.9
621,Mimoso,1183.9,17,7,10,0,41.2%,2024-07-20,0.0
622,DawidSidor,1183.9,24,10,14,0,41.7%,2024-06-07,0.0
623,ciinek,1183.6,7,3,4,0,42.9%,2024-07-17,0.0
624,pawelacb,1183.6,110,50,60,0,45.5%,2025-06-29,+144.8
625,AdaM26,1183.5,7,3,4,0,42.9%,2024-07-06,0.0
626,Afroklauzus,1183.3,2,0,2,0,0.0%,2025-01-16,0.0
627,Demarest,1183.2,221,103,118,0,46.6%,2025-06-24,-89.1
628,SPARTACVS1,1183.0,6,2,4,0,33.3%,2024-10-22,0.0
629,Smn210,1182.9,20,9,11,0,45.0%,2025-05-10,0.0
630,MagK,1182.6,82,44,38,0,53.7%,2025-05-17,0.0
631,Etorion,1182.4,10,4,6,0,40.0%,2024-07-20,0.0
632,Krzysztof135,1182.1,3,1,2,0,33.3%,2024-09-29,0.0
633,ukB,1182.0,5,2,3,0,40.0%,2024-06-29,0.0
634,mfbishop,1182.0,3,1,2,0,33.3%,2024-09-28,0.0
635,Darthanian,1182.0,7,3,4,0,42.9%,2025-04-16,0.0
636,ironshark,1182.0,13,6,7,0,46.2%,2024-04-20,0.0
637,Konioreu,1181.2,394,205,189,0,52.0%,2025-06-19,-80.9
638,Borys Bagrowski,1181.2,43,20,23,0,46.5%,2024-08-31,0.0
639,Kubaaaa,1181.1,6,2,4,0,33.3%,2024-12-17,0.0
640,NeonPL,1181.1,36,16,20,0,44.4%,2025-05-18,0.0
641,wikianna,1180.9,3,1,2,0,33.3%,2025-05-08,0.0
642,Greg_gg,1180.7,9,4,5,0,44.4%,2024-07-17,0.0
643,rozsi,1180.7,22,10,12,0,45.5%,2024-08-31,0.0
644,pacynek22,1180.7,3,1,2,0,33.3%,2025-03-07,0.0
645,MarK38,1180.1,6,2,4,0,33.3%,2025-02-20,0.0
646,Raziel24pl,1180.0,8,2,6,0,25.0%,2024-12-12,0.0
647,OneWinged89,1179.5,8,3,5,0,37.5%,2024-04-27,0.0
648,Kapiszi36,1179.3,36,16,20,0,44.4%,2025-04-27,0.0
649,Kaladln,1179.1,78,39,39,0,50.0%,2024-04-27,0.0
650,RTG_Grummelramme,1178.9,14,6,8,0,42.9%,2025-01-11,0.0
651,koc,1178.9,34,16,18,0,47.1%,2025-06-12,-76.1
652,JNH353001,1178.8,8,4,4,0,50.0%,2024-11-22,0.0
653,ManisStar86,1178.7,4,1,3,0,25.0%,2024-05-16,0.0
654,Diyus,1178.6,22,10,12,0,45.5%,2024-08-31,0.0
655,NapoleonCK,1178.5,8,3,5,0,37.5%,2025-03-22,0.0
656,Rabenstag,1178.0,21,10,11,0,47.6%,2024-04-06,0.0
657,BartPtak,1177.9,6,2,4,0,33.3%,2025-05-08,0.0
658,BarN2,1177.8,7,3,4,0,42.9%,2024-08-03,0.0
659,Salias,1177.5,34,16,18,0,47.1%,2025-05-10,0.0
660,AlcorBuvelle,1177.0,6,2,4,0,33.3%,2025-02-12,0.0
661,MicP37,1176.8,8,3,5,0,37.5%,2024-07-11,0.0
662,Bambusojad,1176.7,34,15,19,0,44.1%,2025-03-24,0.0
663,Vashu,1175.9,13,5,8,0,38.5%,2025-04-23,0.0
664,Nighty1402,1175.8,2,0,2,0,0.0%,2024-08-31,0.0
665,Jan Janda,1175.8,20,9,11,0,45.0%,2024-08-31,0.0
666,GrzesSzczepanski,1175.6,120,56,64,0,46.7%,2025-03-22,0.0
667,Pabiaszek,1175.5,6,2,4,0,33.3%,2024-09-21,0.0
668,KamB3,1175.3,6,2,4,0,33.3%,2024-09-28,0.0
669,mikolajburdak,1175.2,6,2,4,0,33.3%,2025-03-06,0.0
670,AleS69,1175.2,7,3,4,0,42.9%,2024-08-27,0.0
671,SYF792305,1174.5,10,4,6,0,40.0%,2024-09-04,0.0
672,Sanne,1174.0,20,9,11,0,45.0%,2024-04-06,0.0
673,PC,1173.9,9,4,5,0,44.4%,2024-05-10,0.0
674,SewerSnake,1173.8,8,3,5,0,37.5%,2024-08-09,0.0
675,Loknath,1173.7,263,101,162,0,38.4%,2025-05-25,0.0
676,1nd1v1duum,1173.6,2,0,2,0,0.0%,2025-01-11,0.0
677,WikW,1173.5,10,4,6,0,40.0%,2024-10-19,0.0
678,missrabbit,1173.4,14,6,8,0,42.9%,2025-06-25,+18.9
679,Phevhalleh,1173.0,10,4,6,0,40.0%,2024-04-28,0.0
680,Nastka1090,1172.9,4,1,3,0,25.0%,2025-05-08,0.0
681,Karu87,1172.7,2,0,2,0,0.0%,2024-08-11,0.0
682,BarP,1172.7,50,20,30,0,40.0%,2025-06-19,+51.0
683,Champie150,1172.6,6,2,4,0,33.3%,2025-06-29,-27.4
684,Haszi,1172.6,35,16,19,0,45.7%,2025-06-12,+21.1
685,GeAr0wsky,1172.5,2,0,2,0,0.0%,2025-03-22,0.0
686,Klapi,1172.4,4,1,3,0,25.0%,2024-09-08,0.0
687,Kawatek,1172.4,14,6,8,0,42.9%,2024-04-06,0.0
688,WoytekK2013,1172.0,105,49,56,0,46.7%,2025-05-25,0.0
689,RomM6,1171.8,7,2,5,0,28.6%,2024-07-28,0.0
690,EQY169570,1171.0,8,3,5,0,37.5%,2024-10-19,0.0
691,Magyarmango123,1170.1,20,9,11,0,45.0%,2024-04-06,0.0
692,Kenshine,1170.1,6,2,4,0,33.3%,2025-04-01,0.0
693,Wonsacz,1169.7,11,5,6,0,45.5%,2024-08-11,0.0
694,AgataDalecka,1169.6,6,2,4,0,33.3%,2025-02-10,0.0
695,PAB500740,1169.6,10,5,5,0,50.0%,2025-02-21,0.0
696,Denyy5,1168.9,31,12,19,0,38.7%,2025-05-17,0.0
697,fizyk123,1168.9,6,2,4,0,33.3%,2025-06-28,-31.1
698,yankoosky,1168.6,22,9,13,0,40.9%,2025-04-08,0.0
699,Hothgaar,1168.6,6,2,4,0,33.3%,2024-03-29,0.0
700,Terez246,1168.2,10,4,6,0,40.0%,2024-10-19,0.0
701,Kubik11,1167.9,10,4,6,0,40.0%,2024-07-17,0.0
702,Mikous,1167.7,34,14,20,0,41.2%,2025-02-08,0.0
703,PD_Nils,1167.6,18,8,10,0,44.4%,2024-04-06,0.0
704,BJE031751,1167.6,6,2,4,0,33.3%,2025-02-21,0.0
705,Sikor,1167.0,31,15,16,0,48.4%,2024-10-12,0.0
706,susurrus,1166.9,2,0,2,0,0.0%,2024-07-13,0.0
707,Bl3kitny,1166.7,31,13,18,0,41.9%,2024-07-11,0.0
708,LindsayHeming,1166.4,8,3,5,0,37.5%,2024-07-08,0.0
709,Tommiboe,1166.3,18,8,10,0,44.4%,2024-04-06,0.0
710,Hahi956,1166.1,9,3,6,0,33.3%,2024-07-05,0.0
711,ZES917097,1166.1,5,1,4,0,20.0%,2024-09-25,0.0
712,ConsoleChild,1166.1,91,44,47,0,48.4%,2025-05-17,0.0
713,3i,1166.0,6,2,4,0,33.3%,2024-02-24,0.0
714,Axjuu,1165.9,4,1,3,0,25.0%,2024-04-04,0.0
715,PWX043,1165.4,164,79,85,0,48.2%,2025-06-12,+20.0
716,Redil,1165.4,10,4,6,0,40.0%,2024-04-28,0.0
717,Krystian88,1165.4,13,4,9,0,30.8%,2025-05-06,0.0
718,dziam,1165.3,14,5,9,0,35.7%,2024-08-07,0.0
719,EXN185425,1165.2,9,3,6,0,33.3%,2025-02-02,0.0
720,HMV248056,1165.2,8,3,5,0,37.5%,2024-08-21,0.0
721,Whitefox,1165.2,14,5,9,0,35.7%,2025-01-11,0.0
722,Timhalf,1164.3,39,10,29,0,25.6%,2025-06-24,+6.2
723,LDM414484,1164.3,10,4,6,0,40.0%,2025-01-05,0.0
724,SadSeal666,1164.2,6,2,4,0,33.3%,2025-04-14,0.0
725,werner,1164.0,2,0,2,0,0.0%,2024-08-31,0.0
726,ch4ron,1164.0,2,0,2,0,0.0%,2024-04-29,0.0
727,SenQman,1164.0,2,0,2,0,0.0%,2024-05-13,0.0
728,07422ea1e464416db22b5ac967a06f33,1164.0,4,1,3,0,25.0%,2025-04-12,0.0
729,Koziut,1164.0,6,2,4,0,33.3%,2025-02-03,0.0
730,R3K3R,1164.0,4,1,3,0,25.0%,2025-03-07,0.0
731,KatD10,1164.0,4,1,3,0,25.0%,2024-12-14,0.0
732,Rzymoneg,1164.0,4,1,3,0,25.0%,2024-12-14,0.0
733,blakekoks,1164.0,4,1,3,0,25.0%,2024-12-14,0.0
734,Assaika,1164.0,4,1,3,0,25.0%,2024-12-14,0.0
735,MateuszSikoraNet,1164.0,4,1,3,0,25.0%,2025-03-07,0.0
736,crashQueen,1164.0,4,1,3,0,25.0%,2024-12-14,0.0
737,matisiapi,1164.0,2,0,2,0,0.0%,2025-03-07,0.0
738,Chockonessie,1164.0,4,1,3,0,25.0%,2025-03-07,0.0
739,QKC640563,1164.0,6,2,4,0,33.3%,2024-08-21,0.0
740,Asteann,1164.0,4,1,3,0,25.0%,2025-04-12,0.0
741,Fistach,1163.8,6,2,4,0,33.3%,2024-06-22,0.0
742,AJD031416,1163.4,2,0,2,0,0.0%,2025-06-12,-36.6
743,ORV568830,1163.4,6,2,4,0,33.3%,2024-10-13,0.0
744,Miljoneh,1163.3,6,2,4,0,33.3%,2024-03-29,0.0
745,olgam,1162.8,10,3,7,0,30.0%,2025-04-11,0.0
746,MarK37,1162.4,4,1,3,0,25.0%,2024-12-14,0.0
747,szach_m4tt,1162.4,4,1,3,0,25.0%,2024-12-14,0.0
748,Glaree,1162.3,10,3,7,0,30.0%,2024-07-13,0.0
749,Darkcatt,1162.1,2,0,2,0,0.0%,2025-04-12,0.0
750,OverPerson0,1162.0,10,4,6,0,40.0%,2024-07-17,0.0
751,MC_rise,1161.8,20,9,11,0,45.0%,2024-04-06,0.0
752,FVE281330,1161.7,2,0,2,0,0.0%,2025-06-12,-38.3
753,SpoconyKubus,1161.7,4,1,3,0,25.0%,2024-09-11,0.0
754,KorB5,1161.6,6,2,4,0,33.3%,2024-09-12,0.0
755,11ARCEL,1161.4,98,47,51,0,48.0%,2025-03-01,0.0
756,Homer,1161.3,365,184,181,0,50.4%,2025-06-18,+23.2
757,PawK2,1161.1,8,2,6,0,25.0%,2025-02-06,0.0
758,Justyna Spek-Lubska,1160.9,6,2,4,0,33.3%,2024-09-28,0.0
759,KamilZdun,1160.9,24,10,14,0,41.7%,2024-10-20,0.0
760,pogromca36,1160.8,9,3,6,0,33.3%,2024-09-21,0.0
761,goofy18,1160.7,14,5,9,0,35.7%,2025-01-11,0.0
762,CQQ066497,1160.6,6,2,4,0,33.3%,2025-02-21,0.0
763,Aliar,1160.5,16,6,10,0,37.5%,2024-08-12,0.0
764,Kilof_PL,1160.5,24,11,13,0,45.8%,2025-04-02,0.0
765,AvengerPL,1160.1,27,12,15,0,44.4%,2024-03-24,0.0
766,KrzW1,1160.0,4,0,4,0,0.0%,2025-02-06,0.0
767,Homik,1160.0,7,2,5,0,28.6%,2025-04-15,0.0
768,Liverin,1159.5,26,11,15,0,42.3%,2025-02-14,0.0
769,Pein,1159.4,6,2,4,0,33.3%,2024-05-07,0.0
770,SimS15,1159.1,6,2,4,0,33.3%,2024-09-19,0.0
771,LMW448350,1158.9,6,2,4,0,33.3%,2024-10-16,0.0
772,PioK,1158.1,7,2,5,0,28.6%,2024-12-20,0.0
773,sagas13,1157.7,8,2,6,0,25.0%,2025-06-17,-42.3
774,Alan4ev,1157.7,20,9,11,0,45.0%,2024-04-06,0.0
775,RosB9,1157.6,10,4,6,0,40.0%,2025-01-25,0.0
776,4tmp,1157.5,5,1,4,0,20.0%,2025-04-16,0.0
777,RobP26,1157.4,114,49,65,0,43.0%,2025-05-14,0.0
778,Ivysaw,1157.3,2,0,2,0,0.0%,2025-01-11,0.0
779,Swinka_w_Kubku,1157.3,335,155,180,0,46.3%,2025-06-07,-48.9
780,Xoltro,1157.1,91,41,50,0,45.1%,2025-06-10,-91.6
781,HHD231914,1156.7,8,3,5,0,37.5%,2024-11-22,0.0
782,piekarson,1156.7,8,3,5,0,37.5%,2024-11-22,0.0
783,Miłosz Menzler,1156.3,6,2,4,0,33.3%,2024-04-27,0.0
784,XJR836466,1156.3,4,1,3,0,25.0%,2025-02-20,0.0
785,haldir27,1156.0,12,4,8,0,33.3%,2024-07-16,0.0
786,FilipL,1155.5,7,2,5,0,28.6%,2025-04-08,0.0
787,Woytek2013,1155.3,34,15,19,0,44.1%,2025-01-25,0.0
788,RamarMore,1154.7,13,5,8,0,38.5%,2024-04-06,0.0
789,Baksinios,1154.7,6,1,5,0,16.7%,2025-02-03,0.0
790,AnnP4,1154.6,7,2,5,0,28.6%,2024-04-27,0.0
791,Taoczin,1154.5,11,3,8,0,27.3%,2025-04-16,0.0
792,Szpanerski,1154.1,12,4,8,0,33.3%,2024-07-06,0.0
793,Archie04,1153.8,10,4,6,0,40.0%,2024-05-08,0.0
794,Konti,1153.6,31,13,18,0,41.9%,2024-10-12,0.0
795,Dorisday,1152.7,5,1,4,0,20.0%,2025-04-16,0.0
796,karocigaro,1152.7,9,3,6,0,33.3%,2024-06-14,0.0
797,Krawiec73,1152.2,8,2,6,0,25.0%,2025-06-30,-47.8
798,Millamber,1152.1,22,10,12,0,45.5%,2024-07-13,0.0
799,ICQ306890,1152.1,4,0,4,0,0.0%,2025-04-30,0.0
800,Wonski,1152.0,7,2,5,0,28.6%,2024-04-10,0.0
801,SzyG,1151.7,8,2,6,0,25.0%,2024-06-13,0.0
802,Gloobus,1151.1,16,7,9,0,43.8%,2024-04-27,0.0
803,KotoMaja,1150.8,16,6,10,0,37.5%,2025-05-11,0.0
804,NorS5,1150.7,8,3,5,0,37.5%,2024-09-29,0.0
805,Kris Rozycki,1150.3,4,0,4,0,0.0%,2024-09-14,0.0
806,ArkK,1149.9,11,4,7,0,36.4%,2024-06-29,0.0
807,emilkalap,1149.3,6,1,5,0,16.7%,2025-01-16,0.0
808,Mil0oO,1149.3,3,0,3,0,0.0%,2025-04-12,0.0
809,bouchery,1149.1,13,5,8,0,38.5%,2024-04-27,0.0
810,Miadan,1149.0,10,3,7,0,30.0%,2024-10-12,0.0
811,IAW308920,1148.4,6,1,5,0,16.7%,2024-12-11,0.0
812,LSO475165,1148.4,6,1,5,0,16.7%,2024-12-11,0.0
813,RTG_Wombat,1148.4,14,5,9,0,35.7%,2025-01-11,0.0
814,Owiec,1148.3,18,6,12,0,33.3%,2025-06-05,+8.7
815,Apsus,1147.6,20,7,13,0,35.0%,2025-02-01,0.0
816,Zameru,1147.4,9,3,6,0,33.3%,2024-06-21,0.0
817,Combatglue,1147.2,19,8,11,0,42.1%,2024-04-06,0.0
818,Marchesia,1147.2,7,2,5,0,28.6%,2024-04-04,0.0
819,Onnedhiel,1147.0,4,0,4,0,0.0%,2025-01-16,0.0
820,Wilq,1146.9,396,186,210,0,47.0%,2025-06-16,+99.0
821,Kozak,1146.8,15,5,10,0,33.3%,2024-12-14,0.0
822,PVR686527,1146.8,4,0,4,0,0.0%,2025-04-30,0.0
823,Marek88,1146.6,3,0,3,0,0.0%,2024-03-28,0.0
824,DAtSereK,1146.1,22,6,16,0,27.3%,2025-05-25,0.0
825,KXF492804,1146.0,7,2,5,0,28.6%,2024-08-07,0.0
826,Lilith07,1146.0,7,2,5,0,28.6%,2025-02-03,0.0
827,ScaryClock,1146.0,5,1,4,0,20.0%,2024-03-16,0.0
828,Kiyamoro,1146.0,5,1,4,0,20.0%,2025-04-16,0.0
829,cainsel,1145.9,44,18,26,0,40.9%,2025-05-04,0.0
830,TopurmocyK,1145.8,9,3,6,0,33.3%,2024-06-29,0.0
831,Qondziu,1145.4,10,4,6,0,40.0%,2024-10-13,0.0
832,Berestaszek,1144.7,17,7,10,0,41.2%,2024-07-17,0.0
833,qtJanina,1144.6,3,0,3,0,0.0%,2025-03-07,0.0
834,Karccia94,1144.4,40,17,23,0,42.5%,2024-10-21,0.0
835,MKT_FlyingSquirrel,1144.2,28,11,17,0,39.3%,2024-08-31,0.0
836,IwoSlowiki,1144.1,50,22,28,0,44.0%,2025-05-22,0.0
837,zinlynx,1143.5,120,54,66,0,45.0%,2025-05-17,0.0
838,SeraphicSeal,1142.6,8,2,6,0,25.0%,2025-02-10,0.0
839,Splitu,1142.0,26,9,17,0,34.6%,2025-06-07,-13.9
840,MacLizi,1141.9,14,4,10,0,28.6%,2025-02-20,0.0
841,zelcer700,1141.5,7,1,6,0,14.3%,2025-05-06,0.0
842,SanS6,1141.3,3,0,3,0,0.0%,2024-06-06,0.0
843,Gadamorgon,1141.2,8,2,6,0,25.0%,2024-09-11,0.0
844,mecenas,1141.2,4,0,4,0,0.0%,2024-10-01,0.0
845,Rudizel,1141.1,11,4,7,0,36.4%,2024-03-24,0.0
846,Alaghay,1141.0,10,3,7,0,30.0%,2024-04-27,0.0
847,kirun9,1140.7,12,4,8,0,33.3%,2025-04-12,0.0
848,MarcinMarcin,1140.5,3,0,3,0,0.0%,2025-05-15,0.0
849,matB99,1140.3,7,2,5,0,28.6%,2024-08-24,0.0
850,PatD15,1140.1,8,2,6,0,25.0%,2024-06-22,0.0
851,bart13,1139.7,10,3,7,0,30.0%,2025-02-02,0.0
852,AleB97,1139.2,4,0,4,0,0.0%,2024-07-29,0.0
853,Mmas,1139.1,17,6,11,0,35.3%,2024-06-04,0.0
854,alicja,1139.1,21,8,13,0,38.1%,2024-08-11,0.0
855,LZH493529,1138.6,3,0,3,0,0.0%,2024-10-11,0.0
856,HanH8,1138.6,15,6,9,0,40.0%,2024-09-14,0.0
857,Skopex,1138.2,16,6,10,0,37.5%,2025-05-24,0.0
858,koniaczek55,1137.8,8,2,6,0,25.0%,2024-08-30,0.0
859,trexer,1137.7,8,3,5,0,37.5%,2025-04-30,0.0
860,AleP57,1137.7,7,2,5,0,28.6%,2024-08-01,0.0
861,SkladamKlocki,1137.4,313,136,177,0,43.5%,2024-10-12,0.0
862,GRE261078,1137.4,6,1,5,0,16.7%,2025-04-23,0.0
863,martuditu,1137.4,4,0,4,0,0.0%,2024-03-19,0.0
864,MKT_Kevkong,1137.3,34,14,20,0,41.2%,2024-08-31,0.0
865,HerrGrysza,1137.3,8,2,6,0,25.0%,2025-02-01,0.0
866,Ignacy01,1137.0,30,12,18,0,40.0%,2025-04-12,0.0
867,anitroche,1136.8,18,7,11,0,38.9%,2025-06-07,-89.6
868,KrzG,1136.7,9,2,7,0,22.2%,2025-04-30,0.0
869,DaveLodnan,1136.4,14,5,9,0,35.7%,2025-01-11,0.0
870,Malissia,1136.4,6,1,5,0,16.7%,2025-06-16,-63.6
871,GoFFer,1136.3,18,8,10,0,44.4%,2025-02-16,0.0
872,HAN205516,1136.2,6,1,5,0,16.7%,2025-04-23,0.0
873,LauraMarek,1136.0,22,8,14,0,36.4%,2025-03-22,0.0
874,TCR_Auslenderman,1135.9,14,5,9,0,35.7%,2024-08-31,0.0
875,SikhSabre,1135.8,16,7,9,0,43.8%,2025-02-21,0.0
876,AcidBurn,1135.8,4,0,4,0,0.0%,2024-06-21,0.0
877,Ummon,1135.7,161,70,91,0,43.5%,2025-06-30,+17.6
878,NYA590433,1135.6,4,0,4,0,0.0%,2025-02-14,0.0
879,GG_ElMapache,1135.6,14,5,9,0,35.7%,2024-08-31,0.0
880,Trawka,1133.6,12,4,8,0,33.3%,2024-06-20,0.0
881,Czart,1133.6,107,44,63,0,41.1%,2025-06-24,+7.5
882,TymekiIsio,1133.6,28,12,16,0,42.9%,2025-03-01,0.0
883,Wicia,1133.2,32,13,19,0,40.6%,2025-05-25,0.0
884,Azujo,1133.2,10,3,7,0,30.0%,2025-05-18,0.0
885,LorkanowiecOlcia,1132.9,4,0,4,0,0.0%,2024-03-15,0.0
886,JakZ,1132.8,6,0,6,0,0.0%,2024-07-20,0.0
887,OIF532208,1132.1,8,2,6,0,25.0%,2024-08-17,0.0
888,LorKinia,1132.0,14,4,10,0,28.6%,2025-04-24,0.0
889,tobatu,1131.2,12,4,8,0,33.3%,2025-02-08,0.0
890,RAY609015,1131.2,8,2,6,0,25.0%,2025-02-21,0.0
891,Spavvn,1131.1,16,5,11,0,31.2%,2024-10-23,0.0
892,nowiiwon,1130.8,6,1,5,0,16.7%,2024-11-30,0.0
893,Szreniawa,1130.7,31,12,19,0,38.7%,2024-08-13,0.0
894,admiralkuna,1130.6,8,2,6,0,25.0%,2024-07-17,0.0
895,AgnO,1130.2,10,2,8,0,20.0%,2025-06-14,-69.8
896,Piter5,1130.0,10,3,7,0,30.0%,2025-06-29,-70.0
897,Maleante,1129.9,10,2,8,0,20.0%,2025-01-18,0.0
898,yankoos,1129.9,6,1,5,0,16.7%,2025-02-04,0.0
899,IgulaM,1129.7,13,4,9,0,30.8%,2024-06-26,0.0
900,Tymkovsky,1129.6,8,2,6,0,25.0%,2024-07-17,0.0
901,snejku92,1129.6,8,2,6,0,25.0%,2024-04-27,0.0
902,efdee,1129.3,85,35,50,0,41.2%,2025-06-07,-2.4
903,mond3,1129.3,4,0,4,0,0.0%,2024-08-01,0.0
904,Corgimancer,1129.2,11,3,8,0,27.3%,2024-04-03,0.0
905,Kajot,1129.0,42,16,26,0,38.1%,2025-04-26,0.0
906,JasH1,1128.8,18,7,11,0,38.9%,2024-04-06,0.0
907,Vaniliascukor,1128.8,10,3,7,0,30.0%,2024-04-06,0.0
908,kryptofis,1128.7,10,3,7,0,30.0%,2024-07-17,0.0
909,YQG962635,1128.4,8,2,6,0,25.0%,2025-05-22,0.0
910,mateusz2992,1128.3,144,58,86,0,40.3%,2025-06-29,-131.1
911,DYK193516,1128.0,8,2,6,0,25.0%,2024-08-07,0.0
912,kkrawczyk,1128.0,10,3,7,0,30.0%,2024-04-20,0.0
913,varisia4,1128.0,4,0,4,0,0.0%,2025-03-07,0.0
914,PawG1,1128.0,4,0,4,0,0.0%,2024-07-06,0.0
915,TheoPL,1128.0,8,2,6,0,25.0%,2024-06-19,0.0
916,Esteranoemi,1128.0,7,1,6,0,14.3%,2025-02-20,0.0
917,SIV638640,1128.0,8,2,6,0,25.0%,2024-09-21,0.0
918,AdolfHealer,1127.9,8,2,6,0,25.0%,2024-06-12,0.0
919,Yeegor,1127.7,35,14,21,0,40.0%,2025-05-18,0.0
920,RaiVx,1127.4,20,7,13,0,35.0%,2025-01-12,0.0
921,noisy_ofc,1127.3,26,10,16,0,38.5%,2024-07-04,0.0
922,Diables,1126.6,44,17,27,0,38.6%,2025-03-07,0.0
923,Vergal,1126.5,10,3,7,0,30.0%,2024-06-27,0.0
924,gaba_,1126.5,5,0,5,0,0.0%,2025-06-14,-73.5
925,KrzS,1126.3,8,2,6,0,25.0%,2024-06-25,0.0
926,etutuit,1126.0,10,3,7,0,30.0%,2024-07-17,0.0
927,strawb3rryap0cal1pse,1125.8,10,3,7,0,30.0%,2025-04-14,0.0
928,HEQ216085,1125.7,6,1,5,0,16.7%,2025-05-22,0.0
929,Alpa15,1125.4,25,9,16,0,36.0%,2024-09-16,0.0
930,yuuhi666,1125.1,10,3,7,0,30.0%,2025-01-16,0.0
931,TojaMaNa,1124.6,8,2,6,0,25.0%,2025-04-12,0.0
932,mirdhyn,1124.5,7,1,6,0,14.3%,2025-01-26,0.0
933,oladobr,1124.4,41,19,22,0,46.3%,2024-12-07,0.0
934,Bartosz Melka,1124.4,14,6,8,0,42.9%,2025-05-20,0.0
935,Grandasa,1123.9,17,6,11,0,35.3%,2024-06-30,0.0
936,AleW43,1123.7,8,2,6,0,25.0%,2025-01-31,0.0
937,RaV2533,1123.7,53,22,31,0,41.5%,2025-06-16,+20.2
938,happypsycho,1123.7,10,2,8,0,20.0%,2025-06-24,-76.3
939,DCU117083,1123.6,8,2,6,0,25.0%,2025-02-21,0.0
940,Hubert Gromadzki,1123.4,32,12,20,0,37.5%,2024-06-13,0.0
941,Berail,1122.7,4,0,4,0,0.0%,2024-08-11,0.0
942,MarM90,1122.6,111,53,58,0,47.7%,2024-12-07,0.0
943,PDG512694,1122.5,6,1,5,0,16.7%,2025-02-21,0.0
944,Vero320,1122.3,16,6,10,0,37.5%,2025-05-10,0.0
945,KaptainYellow,1122.0,4,0,4,0,0.0%,2024-07-28,0.0
946,Blanek90,1121.9,8,2,6,0,25.0%,2024-07-05,0.0
947,igor1512,1121.3,4,0,4,0,0.0%,2025-02-15,0.0
948,FJR236652,1121.2,6,1,5,0,16.7%,2024-11-06,0.0
949,KryT1,1121.1,77,32,45,0,41.6%,2024-08-12,0.0
950,PatI1,1121.0,9,2,7,0,22.2%,2024-07-27,0.0
951,USB770801,1120.9,8,2,6,0,25.0%,2024-11-22,0.0
952,MiD,1120.9,4,0,4,0,0.0%,2024-08-31,0.0
953,ZuziaHans,1120.7,78,29,49,0,37.2%,2025-03-06,0.0
954,Sm0liv,1120.6,18,5,13,0,27.8%,2025-05-26,0.0
955,Toster,1120.5,6,0,6,0,0.0%,2024-12-21,0.0
956,FTP,1120.0,26,10,16,0,38.5%,2025-02-08,0.0
957,Bartosz Skop,1119.9,27,10,17,0,37.0%,2025-05-24,0.0
958,Tigertrouble07,1119.8,7,1,6,0,14.3%,2024-07-19,0.0
959,RadT,1119.0,6,1,5,0,16.7%,2024-05-27,0.0
960,PappaR0o,1118.6,18,7,11,0,38.9%,2024-04-06,0.0
961,LeWsha,1118.3,6,0,6,0,0.0%,2025-04-08,0.0
962,Lenexx,1118.2,6,1,5,0,16.7%,2025-02-10,0.0
963,Cukierikisiel,1117.6,62,24,38,0,38.7%,2025-05-19,0.0
964,TamH1,1117.4,21,8,13,0,38.1%,2024-04-06,0.0
965,myrynde,1117.4,6,1,5,0,16.7%,2024-09-15,0.0
966,Tejros,1117.2,7,1,6,0,14.3%,2024-06-12,0.0
967,Halsik,1116.9,20,7,13,0,35.0%,2024-09-16,0.0
968,przck_jerzykmach,1116.8,82,38,44,0,46.3%,2025-06-07,-29.7
969,Naiilo,1116.7,11,3,8,0,27.3%,2024-04-28,0.0
970,PanOzzie,1116.7,20,6,14,0,30.0%,2025-05-10,0.0
971,Treblacz,1116.5,9,2,7,0,22.2%,2024-04-06,0.0
972,Brothu,1115.9,7,1,6,0,14.3%,2024-09-26,0.0
973,Wiskor,1115.9,15,5,10,0,33.3%,2024-07-17,0.0
974,PatS39,1115.5,7,1,6,0,14.3%,2025-05-04,0.0
975,xing1992,1115.0,20,6,14,0,30.0%,2025-06-28,-6.8
976,Marci1989,1114.6,21,8,13,0,38.1%,2024-04-06,0.0
977,Lucjabassendowska,1114.4,6,0,6,0,0.0%,2024-10-26,0.0
978,karl7035,1114.3,8,1,7,0,12.5%,2025-05-24,0.0
979,AdaS35,1114.3,8,2,6,0,25.0%,2025-06-14,-85.7
980,maciekr,1114.0,14,4,10,0,28.6%,2024-09-28,0.0
981,Wizzu,1113.9,7,1,6,0,14.3%,2024-06-20,0.0
982,UQX769752,1113.7,8,2,6,0,25.0%,2024-11-22,0.0
983,Szywka,1113.5,134,54,80,0,40.3%,2025-06-20,+0.1
984,MuNiEk,1113.4,19,7,12,0,36.8%,2024-08-11,0.0
985,AxeT0,1113.3,6,0,6,0,0.0%,2025-05-10,0.0
986,FranekP,1113.2,10,2,8,0,20.0%,2024-09-28,0.0
987,Konrax,1112.7,6,0,6,0,0.0%,2025-03-29,0.0
988,WNC850976,1112.6,8,2,6,0,25.0%,2025-05-22,0.0
989,xxtr3t,1112.6,6,0,6,0,0.0%,2025-05-29,0.0
990,GrubySid,1112.1,82,33,49,0,40.2%,2024-11-21,0.0
991,figiel,1111.9,4,0,4,0,0.0%,2024-08-20,0.0
992,Amtrue,1111.3,9,2,7,0,22.2%,2024-07-17,0.0
993,DEREK1982,1111.0,7,1,6,0,14.3%,2024-03-19,0.0
994,Kubekja,1110.2,18,6,12,0,33.3%,2025-04-12,0.0
995,Bartłomiej Łakuta,1110.1,56,22,34,0,39.3%,2024-07-11,0.0
996,Ventreel,1110.1,9,2,7,0,22.2%,2024-04-17,0.0
997,Krzysiu,1110.0,7,1,6,0,14.3%,2025-02-03,0.0
998,dawids,1110.0,9,2,7,0,22.2%,2024-04-20,0.0
999,Michal Valenta,1110.0,9,2,7,0,22.2%,2024-04-06,0.0
1000,Mag_nolia,1110.0,7,1,6,0,14.3%,2024-03-25,0.0
1001,Semiadei,1109.6,429,218,211,0,50.8%,2025-06-16,-68.8
1002,Slidii,1109.3,7,1,6,0,14.3%,2024-07-17,0.0
1003,Jovonto,1109.3,6,0,6,0,0.0%,2024-09-10,0.0
1004,Jakub Wlazło,1109.1,173,65,108,0,37.6%,2025-06-28,+21.4
1005,vecnov,1108.5,19,7,12,0,36.8%,2024-04-06,0.0
1006,witpab7,1108.3,17,5,12,0,29.4%,2025-05-18,0.0
1007,LCN_UniSushi,1108.2,15,5,10,0,33.3%,2024-04-06,0.0
1008,blackmaq,1108.0,10,2,8,0,20.0%,2025-01-04,0.0
1009,KarK11,1108.0,8,2,6,0,25.0%,2025-02-20,0.0
1010,moorx,1107.8,25,9,16,0,36.0%,2024-12-22,0.0
1011,Yoshin73,1107.1,110,42,68,0,38.2%,2025-06-24,+125.3
1012,MagL1,1106.5,7,1,6,0,14.3%,2024-10-04,0.0
1013,DiscoBurger,1106.2,656,332,324,0,50.6%,2025-06-19,+26.8
1014,Amina,1106.1,35,15,20,0,42.9%,2024-10-04,0.0
1015,siudiniii,1105.8,10,3,7,0,30.0%,2025-02-01,0.0
1016,olaf10,1105.7,6,0,6,0,0.0%,2025-03-30,0.0
1017,Piotrek,1105.4,53,21,32,0,39.6%,2025-01-25,0.0
1018,juns1,1105.1,33,13,20,0,39.4%,2025-05-04,0.0
1019,Kooozy,1104.8,26,8,18,0,30.8%,2025-07-01,+39.9
1020,Pawlax,1104.6,110,48,62,0,43.6%,2024-11-25,0.0
1021,Dagome,1104.2,6,0,6,0,0.0%,2025-06-28,-95.8
1022,PioG,1104.2,12,4,8,0,33.3%,2025-03-20,0.0
1023,Gwidon,1103.9,11,3,8,0,27.3%,2025-03-20,0.0
1024,TVSZYSZKA,1103.7,6,0,6,0,0.0%,2025-06-01,-96.3
1025,AIJ033051,1103.1,8,2,6,0,25.0%,2025-02-21,0.0
1026,ichri,1103.0,7,1,6,0,14.3%,2024-07-20,0.0
1027,Chase_the_rogue,1102.9,6,0,6,0,0.0%,2024-05-31,0.0
1028,TymW1,1101.9,8,1,7,0,12.5%,2025-06-12,-98.1
1029,mojaosoba,1101.3,17,6,11,0,35.3%,2025-05-24,0.0
1030,Gdziejestpanda,1101.2,68,23,45,0,33.8%,2025-06-19,-20.8
1031,Marianna,1100.7,9,2,7,0,22.2%,2024-10-20,0.0
1032,capek,1100.1,35,14,21,0,40.0%,2024-04-10,0.0
1033,Kaja,1100.1,12,4,8,0,33.3%,2024-10-05,0.0
1034,MatsonDon,1100.0,8,1,7,0,12.5%,2024-07-13,0.0
1035,Vokulski,1100.0,6,0,6,0,0.0%,2025-04-02,0.0
1036,Aquiver,1099.6,16,4,12,0,25.0%,2025-05-10,0.0
1037,dagorek,1099.3,14,2,12,0,14.3%,2024-10-21,0.0
1038,MaciekBochenski,1099.2,46,14,32,0,30.4%,2025-06-17,-88.5
1039,Szczeglak,1098.5,7,1,6,0,14.3%,2024-04-24,0.0
1040,Pynio,1098.3,6,0,6,0,0.0%,2024-06-24,0.0
1041,NerN,1097.8,7,1,6,0,14.3%,2024-08-29,0.0
1042,Adam_1313,1097.6,8,0,8,0,0.0%,2025-05-27,0.0
1043,KratkaCraft,1097.6,11,2,9,0,18.2%,2024-10-17,0.0
1044,Bart87,1097.4,6,0,6,0,0.0%,2025-02-01,0.0
1045,deffym,1097.4,54,17,37,0,31.5%,2025-06-18,-8.4
1046,mushu76,1097.3,6,0,6,0,0.0%,2025-04-09,0.0
1047,MatD67,1097.3,18,5,13,0,27.8%,2024-11-27,0.0
1048,limonti,1097.3,6,0,6,0,0.0%,2024-03-20,0.0
1049,RobooWoo,1097.2,6,0,6,0,0.0%,2024-03-29,0.0
1050,vinograpsov,1097.2,6,0,6,0,0.0%,2025-01-09,0.0
1051,Lambo27c,1097.0,6,0,6,0,0.0%,2024-12-18,0.0
1052,DizzyPig,1096.9,13,3,10,0,23.1%,2025-05-24,0.0
1053,ola537,1096.2,108,35,73,0,32.4%,2025-07-01,+182.9
1054,marb112,1095.5,6,0,6,0,0.0%,2024-08-01,0.0
1055,KacR,1095.4,6,0,6,0,0.0%,2024-08-15,0.0
1056,Tanarial,1095.1,8,1,7,0,12.5%,2024-08-22,0.0
1057,WZX898962,1094.0,6,0,6,0,0.0%,2024-09-21,0.0
1058,KasztanKolektor,1093.0,6,0,6,0,0.0%,2024-07-06,0.0
1059,EmperorKarlito,1092.6,16,5,11,0,31.2%,2024-12-09,0.0
1060,WERNER_,1092.4,27,10,17,0,37.0%,2024-04-06,0.0
1061,Drix,1092.0,6,0,6,0,0.0%,2024-02-20,0.0
1062,Plectra,1092.0,12,3,9,0,25.0%,2024-04-06,0.0
1063,OliwkaBogusz,1092.0,8,1,7,0,12.5%,2024-09-21,0.0
1064,Sneaky,1092.0,20,7,13,0,35.0%,2024-04-06,0.0
1065,Kacper90,1091.7,23,8,15,0,34.8%,2025-05-18,0.0
1066,Marta123,1091.6,236,96,140,0,40.7%,2025-03-01,0.0
1067,micjun,1091.1,95,32,63,0,33.7%,2025-02-08,0.0
1068,Anbaca,1090.9,6,0,6,0,0.0%,2025-05-28,0.0
1069,ULG742007,1090.8,6,0,6,0,0.0%,2025-02-21,0.0
1070,SMD741796,1090.7,6,0,6,0,0.0%,2025-05-22,0.0
1071,Katalen,1090.7,6,0,6,0,0.0%,2025-04-25,0.0
1072,Pitererek,1090.6,10,2,8,0,20.0%,2025-01-25,0.0
1073,Chapter,1090.5,14,4,10,0,28.6%,2025-01-15,0.0
1074,Cube011806,1090.2,168,72,96,0,42.9%,2025-06-10,-107.6
1075,Dmnk,1089.8,11,2,9,0,18.2%,2024-09-05,0.0
1076,MVRE,1089.8,43,15,28,0,34.9%,2025-06-25,-23.0
1077,lgajewski,1089.6,22,6,16,0,27.3%,2025-01-12,0.0
1078,NelaK8,1089.0,67,29,38,0,43.3%,2025-06-07,-53.3
1079,Manniek,1088.9,128,53,75,0,41.4%,2025-06-22,+1.1
1080,BarteM,1088.8,28,10,18,0,35.7%,2024-06-11,0.0
1081,Fishu,1088.7,144,50,94,0,34.7%,2025-07-01,-43.7
1082,JulK7,1088.4,9,1,8,0,11.1%,2024-07-12,0.0
1083,Ackermann,1088.1,24,7,17,0,29.2%,2025-03-01,0.0
1084,bimyou,1087.8,12,3,9,0,25.0%,2025-04-27,0.0
1085,Bazarek,1087.7,115,44,71,0,38.3%,2025-05-17,0.0
1086,Julvbro,1087.6,8,1,7,0,12.5%,2025-01-07,0.0
1087,faj,1086.5,20,5,15,0,25.0%,2025-04-01,0.0
1088,Woocash,1086.5,70,25,45,0,35.7%,2025-06-27,+16.0
1089,CreezzU,1086.1,7,0,7,0,0.0%,2025-02-20,0.0
1090,JSokolski,1085.8,37,11,26,0,29.7%,2024-07-07,0.0
1091,c4lvo,1085.5,12,2,10,0,16.7%,2025-01-11,0.0
1092,Krzysztof Kotowski,1085.3,14,3,11,0,21.4%,2025-05-24,0.0
1093,ALLSHAQ,1085.1,14,4,10,0,28.6%,2025-03-01,0.0
1094,Nikolula,1084.5,10,2,8,0,20.0%,2024-07-07,0.0
1095,Mikolaj,1084.2,24,8,16,0,33.3%,2025-06-25,-85.1
1096,haeno,1083.3,6,0,6,0,0.0%,2025-04-03,0.0
1097,Kasia11,1083.3,17,5,12,0,29.4%,2024-06-27,0.0
1098,Szafran,1083.2,8,1,7,0,12.5%,2025-01-07,0.0
1099,Tahara,1083.1,12,2,10,0,16.7%,2024-09-29,0.0
1100,KimiSama,1082.7,8,0,8,0,0.0%,2024-11-13,0.0
1101,Leonator,1082.7,35,12,23,0,34.3%,2025-05-07,0.0
1102,289bb7e67ec5472790580f6999f28b70,1082.4,6,0,6,0,0.0%,2025-01-26,0.0
1103,Matajsen,1082.0,26,8,18,0,30.8%,2025-04-24,0.0
1104,Jawor,1081.8,19,5,14,0,26.3%,2024-07-21,0.0
1105,Krzychu,1081.8,113,43,70,0,38.1%,2025-06-26,-101.3
1106,Ryjek,1081.4,38,15,23,0,39.5%,2025-02-02,0.0
1107,Bibi_M,1080.7,25,7,18,0,28.0%,2025-05-18,0.0
1108,Mayster,1080.4,6,0,6,0,0.0%,2025-02-27,0.0
1109,CristopherRobin,1080.3,8,0,8,0,0.0%,2025-05-13,0.0
1110,St4chu564,1079.7,14,3,11,0,21.4%,2025-06-07,-120.3
1111,Sean O'Neil,1079.0,23,7,16,0,30.4%,2024-10-24,0.0
1112,TenTypBlaze,1078.8,49,18,31,0,36.7%,2024-10-20,0.0
1113,AgataWK8,1078.2,10,2,8,0,20.0%,2025-01-26,0.0
1114,Fifii,1077.1,53,21,32,0,39.6%,2025-02-02,0.0
1115,Ewelina,1076.4,52,22,30,0,42.3%,2025-05-18,0.0
1116,NTB570773,1076.0,10,2,8,0,20.0%,2024-10-05,0.0
1117,chciwyB,1076.0,31,11,20,0,35.5%,2024-07-28,0.0
1118,Adamczyca,1075.7,37,12,25,0,32.4%,2024-12-03,0.0
1119,Rejnbol,1075.0,9,1,8,0,11.1%,2024-08-11,0.0
1120,Kacpi,1074.9,13,3,10,0,23.1%,2025-05-08,0.0
1121,Desaix1800,1074.8,16,4,12,0,25.0%,2024-03-24,0.0
1122,Suzbert,1074.8,8,1,7,0,12.5%,2025-06-11,-125.2
1123,Psyhraode,1074.6,43,15,28,0,34.9%,2025-01-25,0.0
1124,KirK,1074.2,41,17,24,0,41.5%,2024-12-12,0.0
1125,KasB3,1074.1,52,23,29,0,44.2%,2025-04-24,0.0
1126,QHZ629436,1074.1,9,1,8,0,11.1%,2025-02-02,0.0
1127,DaxiDexter,1073.9,31,10,21,0,32.3%,2024-08-06,0.0
1128,Roxasek,1073.2,22,5,17,0,22.7%,2025-06-09,+14.1
1129,KorneliaPekala,1072.7,60,24,36,0,40.0%,2025-05-14,0.0
1130,Krol1515,1071.6,9,1,8,0,11.1%,2024-04-10,0.0
1131,rudy123pl,1071.3,33,11,22,0,33.3%,2024-10-12,0.0
1132,ManieQ,1070.9,530,240,290,0,45.3%,2025-06-28,-38.4
1133,Osel,1070.6,54,18,36,0,33.3%,2025-04-14,0.0
1134,pavelclapka,1070.2,22,6,16,0,27.3%,2025-01-11,0.0
1135,TolmOrken,1070.1,63,23,40,0,36.5%,2025-05-11,0.0
1136,Owczy83,1068.8,9,1,8,0,11.1%,2024-09-28,0.0
1137,Horus32,1067.4,8,0,8,0,0.0%,2024-04-20,0.0
1138,Germanmaggot,1067.2,20,6,14,0,30.0%,2024-04-06,0.0
1139,Malpiacci,1066.7,110,50,60,0,45.5%,2025-02-19,0.0
1140,xbartix,1064.6,8,0,8,0,0.0%,2024-12-17,0.0
1141,Michalek11,1064.3,10,1,9,0,10.0%,2025-02-08,0.0
1142,RedPanda,1063.9,45,17,28,0,37.8%,2025-03-07,0.0
1143,PiotrjrDer,1063.8,14,3,11,0,21.4%,2025-05-08,0.0
1144,Kayoh,1063.4,21,7,14,0,33.3%,2025-02-08,0.0
1145,Agrippa,1063.3,24,8,16,0,33.3%,2025-06-07,-29.7
1146,Tescatlipoca,1062.4,8,0,8,0,0.0%,2024-04-28,0.0
1147,ZZ_top,1062.1,9,1,8,0,11.1%,2024-06-26,0.0
1148,Impulsek,1061.8,7,0,7,0,0.0%,2025-02-13,0.0
1149,Sztefan,1061.2,31,10,21,0,32.3%,2025-03-01,0.0
1150,Miszel,1059.5,53,19,34,0,35.8%,2025-06-09,-84.0
1151,Gruwski,1059.4,273,85,188,0,31.1%,2025-06-29,+242.5
1152,Netaev,1058.9,48,16,32,0,33.3%,2025-04-24,0.0
1153,TataBartek,1058.9,20,6,14,0,30.0%,2024-05-10,0.0
1154,jarj7,1058.5,8,0,8,0,0.0%,2024-09-26,0.0
1155,Naruciak,1058.0,40,13,27,0,32.5%,2025-06-07,+17.7
1156,SirChaosI,1057.4,26,8,18,0,30.8%,2025-03-01,0.0
1157,ashek,1057.0,14,3,11,0,21.4%,2025-01-11,0.0
1158,KacZ,1056.7,44,17,27,0,38.6%,2025-02-11,0.0
1159,Wozziiu,1056.0,8,0,8,0,0.0%,2024-06-19,0.0
1160,JasiekM,1055.8,26,8,18,0,30.8%,2025-06-22,+17.6
1161,ximinin,1055.3,14,3,11,0,21.4%,2024-09-11,0.0
1162,CierniaX,1054.7,16,3,13,0,18.8%,2025-04-10,0.0
1163,Sir77778,1054.0,18,5,13,0,27.8%,2024-04-06,0.0
1164,silvar,1053.8,24,9,15,0,37.5%,2025-02-02,0.0
1165,AdaK9,1053.0,189,72,117,0,38.1%,2025-06-21,+107.1
1166,Graati,1052.7,52,20,32,0,38.5%,2025-05-13,0.0
1167,Teshi,1051.7,12,2,10,0,16.7%,2025-06-07,-148.3
1168,jagerbomb,1051.3,17,5,12,0,29.4%,2025-02-26,0.0
1169,localcryptid,1050.8,32,9,23,0,28.1%,2024-07-02,0.0
1170,AlcorKagura,1050.7,15,4,11,0,26.7%,2024-09-11,0.0
1171,GG_andi99,1050.0,30,10,20,0,33.3%,2024-08-31,0.0
1172,AGA1981,1048.8,8,0,8,0,0.0%,2024-06-18,0.0
1173,Hamlecik,1048.0,13,1,12,0,7.7%,2025-02-20,0.0
1174,OleO,1047.6,21,7,14,0,33.3%,2024-09-14,0.0
1175,GrzA,1046.3,22,6,16,0,27.3%,2025-02-02,0.0
1176,WojciechOlszta,1046.0,8,0,8,0,0.0%,2024-04-28,0.0
1177,Mateuszpp,1045.9,16,3,13,0,18.8%,2024-09-16,0.0
1178,Tener7,1043.8,48,14,34,0,29.2%,2025-06-27,-3.4
1179,Zergulek,1043.4,209,76,133,0,36.4%,2025-06-18,-85.5
1180,Lumeros,1043.3,25,8,17,0,32.0%,2024-10-06,0.0
1181,TataTheFrench,1042.3,20,4,16,0,20.0%,2025-03-06,0.0
1182,Babyface_Assassin,1041.6,75,29,46,0,38.7%,2025-03-01,0.0
1183,Szczepan,1041.0,27,7,20,0,25.9%,2024-07-25,0.0
1184,NDOS,1040.7,137,49,88,0,35.8%,2024-11-26,0.0
1185,TomP12,1040.5,29,8,21,0,27.6%,2024-12-12,0.0
1186,Xamailo,1040.4,368,143,225,0,38.9%,2025-05-27,0.0
1187,Jankesjano,1039.7,42,15,27,0,35.7%,2025-06-17,+12.7
1188,jaku06,1039.5,8,0,8,0,0.0%,2025-06-17,-160.5
1189,AKrynskaT8,1039.1,106,49,57,0,46.2%,2025-06-07,-30.3
1190,dmz1978,1038.5,10,1,9,0,10.0%,2024-12-15,0.0
1191,Kowciu,1038.1,52,16,36,0,30.8%,2025-01-11,0.0
1192,Danio,1037.3,11,1,10,0,9.1%,2024-04-06,0.0
1193,Marianczos,1037.1,36,11,25,0,30.6%,2025-06-21,+13.8
1194,amber4249,1035.7,12,1,11,0,8.3%,2024-06-22,0.0
1195,NataliaK15,1035.6,136,45,91,0,33.1%,2025-06-11,+85.6
1196,Rzepix04,1035.4,21,4,17,0,19.0%,2025-03-22,0.0
1197,FilipKania,1034.8,14,2,12,0,14.3%,2025-02-01,0.0
1198,kamil,1034.0,207,87,120,0,42.0%,2024-07-28,0.0
1199,IgaK,1034.0,191,84,107,0,44.0%,2025-06-21,-36.2
1200,kamilw,1033.9,39,12,27,0,30.8%,2025-06-28,-6.4
1201,Fronckowsky,1033.3,30,9,21,0,30.0%,2025-06-12,+17.4
1202,Fia,1032.9,17,3,14,0,17.6%,2024-03-19,0.0
1203,VKO845746,1032.7,10,0,10,0,0.0%,2024-10-19,0.0
1204,Advzuzzie,1031.6,43,13,30,0,30.2%,2025-06-28,+17.1
1205,MakK,1030.9,16,3,13,0,18.8%,2024-08-03,0.0
1206,klaczek,1030.4,20,3,17,0,15.0%,2025-05-10,0.0
1207,AdamKosecki,1029.1,137,44,93,0,32.1%,2025-06-23,+113.1
1208,Anise,1027.0,24,6,18,0,25.0%,2024-07-06,0.0
1209,JakC10,1026.3,193,78,115,0,40.4%,2025-06-12,-3.2
1210,Jmleczko82,1026.2,90,34,56,0,37.8%,2024-12-07,0.0
1211,b3r53rk3r,1026.1,126,50,76,0,39.7%,2025-06-24,+3.3
1212,Helenka44,1025.7,20,6,14,0,30.0%,2025-05-24,0.0
1213,guidogg,1025.2,18,4,14,0,22.2%,2025-05-24,0.0
1214,marysia21,1025.1,16,2,14,0,12.5%,2025-06-26,-73.2
1215,Fosgen2004,1023.5,16,2,14,0,12.5%,2025-02-01,0.0
1216,Shiruma,1022.5,21,5,16,0,23.8%,2025-05-25,0.0
1217,DomC9,1022.3,14,2,12,0,14.3%,2025-04-08,0.0
1218,Wacho,1022.3,14,2,12,0,14.3%,2024-06-19,0.0
1219,hadh,1021.7,19,4,15,0,21.1%,2024-10-03,0.0
1220,Joanna,1021.4,12,1,11,0,8.3%,2025-04-27,0.0
1221,JakP13,1020.5,12,0,12,0,0.0%,2025-04-16,0.0
1222,Wolvson,1020.2,36,12,24,0,33.3%,2025-05-10,0.0
1223,MarK18,1018.5,10,0,10,0,0.0%,2024-04-27,0.0
1224,fdyduch,1018.3,64,19,45,0,29.7%,2025-06-28,+64.6
1225,JanHenel,1016.6,129,52,77,0,40.3%,2025-06-07,-28.1
1226,PokeNik,1016.0,20,5,15,0,25.0%,2024-04-06,0.0
1227,Amalka,1015.6,23,6,17,0,26.1%,2024-10-05,0.0
1228,Demidmi,1015.6,28,7,21,0,25.0%,2025-06-20,-46.5
1229,Malgi93,1014.7,13,1,12,0,7.7%,2024-08-11,0.0
1230,ucK,1014.5,188,94,94,0,50.0%,2025-06-21,-93.6
1231,SteM23,1013.1,10,0,10,0,0.0%,2025-01-11,0.0
1232,Artemizu,1011.3,71,23,48,0,32.4%,2025-05-25,0.0
1233,Radbies,1009.1,19,4,15,0,21.1%,2025-05-18,0.0
1234,Seniorasty,1008.8,18,3,15,0,16.7%,2024-04-28,0.0
1235,Twicefun,1005.3,34,11,23,0,32.4%,2024-04-23,0.0
1236,Mateusz Kapała,1005.0,36,9,27,0,25.0%,2025-05-17,0.0
1237,Czerwony_smok,1003.8,37,11,26,0,29.7%,2025-01-25,0.0
1238,Piotr212,1002.6,14,1,13,0,7.1%,2024-05-08,0.0
1239,JulekDas,1001.9,130,46,84,0,35.4%,2025-05-27,0.0
1240,mich4lsk4,1000.1,28,8,20,0,28.6%,2024-10-12,0.0
1241,JanekMelka,1000.1,42,15,27,0,35.7%,2025-06-24,-100.8
1242,BarBarJan,999.9,135,53,82,0,39.3%,2025-06-24,+11.7
1243,Bobek,999.7,135,40,95,0,29.6%,2025-06-29,+113.1
1244,YyyyWhatever,999.5,18,3,15,0,16.7%,2024-09-16,0.0
1245,LisNightfall,999.5,14,1,13,0,7.1%,2025-06-21,-130.2
1246,nanyax,999.0,15,1,14,0,6.7%,2025-04-09,0.0
1247,JanZ2,998.7,12,0,12,0,0.0%,2024-08-31,0.0
1248,Zwierzak,998.5,26,5,21,0,19.2%,2025-04-27,0.0
1249,KukiBuki,996.0,111,36,75,0,32.4%,2025-05-25,0.0
1250,Elsandir,995.8,95,36,59,0,37.9%,2025-04-27,0.0
1251,Zgon,994.7,35,11,24,0,31.4%,2024-12-09,0.0
1252,Straszan,993.0,49,14,35,0,28.6%,2025-02-02,0.0
1253,Cejrondo,992.5,44,13,31,0,29.5%,2024-09-11,0.0
1254,Mikołaj Dalecki,991.8,14,1,13,0,7.1%,2025-02-10,0.0
1255,Dyzzma,990.0,20,2,18,0,10.0%,2025-06-26,-13.3
1256,Badyl,989.2,18,2,16,0,11.1%,2024-09-29,0.0
1257,Asix,988.1,14,0,14,0,0.0%,2025-06-08,-211.9
1258,Jankes,987.5,49,17,32,0,34.7%,2024-08-12,0.0
1259,PeterL1,986.4,24,5,19,0,20.8%,2025-04-27,0.0
1260,zdun1203,984.2,18,2,16,0,11.1%,2025-01-12,0.0
1261,Raamiel,982.8,122,46,76,0,37.7%,2025-05-24,0.0
1262,MissDarkness,981.8,41,12,29,0,29.3%,2025-05-10,0.0
1263,Sakul8,980.9,26,6,20,0,23.1%,2025-05-24,0.0
1264,MicP45,980.7,57,19,38,0,33.3%,2024-10-08,0.0
1265,Veislyn,979.9,146,52,94,0,35.6%,2025-05-24,0.0
1266,Maciek93,979.0,58,18,40,0,31.0%,2024-06-18,0.0
1267,M00DY,978.5,56,17,39,0,30.4%,2025-02-17,0.0
1268,Mikuu,977.0,20,3,17,0,15.0%,2024-07-13,0.0
1269,Lilipup,976.3,52,18,34,0,34.6%,2024-10-04,0.0
1270,Wani,976.2,81,29,52,0,35.8%,2025-02-02,0.0
1271,Muffincia,973.4,209,57,152,0,27.3%,2025-06-30,+60.4
1272,Deckson,973.2,53,16,37,0,30.2%,2025-01-25,0.0
1273,misiek,973.2,47,11,36,0,23.4%,2025-06-28,+14.8
1274,bartoskr,971.9,26,3,23,0,11.5%,2024-12-21,0.0
1275,kumosss,971.1,66,18,48,0,27.3%,2024-10-21,0.0
1276,NessieLaufeyson,970.8,17,1,16,0,5.9%,2024-06-12,0.0
1277,KristinaL,970.6,16,1,15,0,6.2%,2025-04-03,0.0
1278,Martosm,970.5,169,43,126,0,25.4%,2025-06-30,-11.3
1279,Awee,969.0,30,7,23,0,23.3%,2025-06-20,-31.9
1280,Hatieusz,966.3,141,52,89,0,36.9%,2024-08-29,0.0
1281,ndyduch,964.7,28,7,21,0,25.0%,2025-06-18,-22.9
1282,Piotr_Preneta,964.1,100,37,63,0,37.0%,2025-04-10,0.0
1283,McTimon,961.6,26,4,22,0,15.4%,2025-05-10,0.0
1284,Belzedub999,960.3,24,5,19,0,20.8%,2025-05-18,0.0
1285,binkiewiczjoanna5,959.4,16,1,15,0,6.2%,2024-10-06,0.0
1286,Saper,959.0,427,147,280,0,34.4%,2025-06-24,+75.2
1287,Maru20,957.2,186,84,102,0,45.2%,2025-06-16,-5.2
1288,Daisy_,956.0,63,23,40,0,36.5%,2024-08-25,0.0
1289,Niziolek,953.4,101,32,69,0,31.7%,2024-10-19,0.0
1290,kamienny,950.9,18,0,18,0,0.0%,2025-04-17,0.0
1291,Tynajus,949.9,181,71,110,0,39.2%,2025-06-04,+3.3
1292,Jolalola,948.4,76,28,48,0,36.8%,2024-08-09,0.0
1293,Radek,947.9,45,14,31,0,31.1%,2024-08-12,0.0
1294,Savio,947.8,32,6,26,0,18.8%,2025-03-01,0.0
1295,Oleh Dombrovskyi,945.5,89,27,62,0,30.3%,2025-04-03,0.0
1296,OrajoN,943.2,29,6,23,0,20.7%,2025-03-18,0.0
1297,KajteK,942.5,42,12,30,0,28.6%,2025-02-15,0.0
1298,Jakubn,941.6,30,2,28,0,6.7%,2025-06-19,-15.2
1299,Ania,937.9,44,8,36,0,18.2%,2025-06-19,-65.2
1300,eisswobniar,935.8,26,5,21,0,19.2%,2025-06-12,-78.3
1301,Krzysztof Kościelniak,934.4,28,5,23,0,17.9%,2024-07-13,0.0
1302,werciachelcho,928.2,152,64,88,0,42.1%,2025-03-19,0.0
1303,mlodysynowiec,928.1,36,6,30,0,16.7%,2025-05-14,0.0
1304,LittleZorgon,925.9,55,17,38,0,30.9%,2025-06-04,-52.3
1305,Krg88,919.6,72,22,50,0,30.6%,2025-06-12,-55.7
1306,FlaminDiesel,919.3,24,3,21,0,12.5%,2025-04-01,0.0
1307,Ignatio,919.2,46,13,33,0,28.3%,2025-05-25,0.0
1308,Gnom,916.3,31,5,26,0,16.1%,2025-04-03,0.0
1309,CarbonPurple,914.9,52,15,37,0,28.8%,2024-08-31,0.0
1310,WojN,914.8,153,54,99,0,35.3%,2025-06-26,+17.9
1311,Demonter,914.2,36,9,27,0,25.0%,2024-10-04,0.0
1312,Jel0nka,912.9,114,36,78,0,31.6%,2025-03-28,0.0
1313,BROdzixON,910.4,236,79,157,0,33.5%,2025-03-07,0.0
1314,Kumkwatek,907.6,24,2,22,0,8.3%,2025-01-22,0.0
1315,Mams,905.4,21,1,20,0,4.8%,2024-10-12,0.0
1316,ponczek,905.1,65,15,50,0,23.1%,2025-02-01,0.0
1317,Pashu,904.6,59,15,44,0,25.4%,2024-10-15,0.0
1318,TempestMonarch,904.4,134,48,86,0,35.8%,2025-06-14,+59.4
1319,AgnW,902.6,103,30,73,0,29.1%,2025-06-26,-55.7
1320,feyrakedi,902.5,32,6,26,0,18.8%,2025-05-10,0.0
1321,Gremlin2013,902.0,57,14,43,0,24.6%,2025-04-10,0.0
1322,Lorasyko,901.2,240,69,171,0,28.7%,2025-06-29,+237.6
1323,JanZ3,901.2,18,0,18,0,0.0%,2024-09-04,0.0
1324,FraB44,898.2,36,7,29,0,19.4%,2025-06-21,-78.9
1325,Rewol,895.5,24,2,22,0,8.3%,2024-05-07,0.0
1326,SebS3,893.9,29,4,25,0,13.8%,2025-01-16,0.0
1327,Wampierz,892.6,145,53,92,0,36.6%,2025-05-24,0.0
1328,Pyszanna,888.3,52,12,40,0,23.1%,2025-04-27,0.0
1329,AdamTCGLorcana,887.9,38,5,33,0,13.2%,2025-06-08,-68.5
1330,Trojan,886.2,22,1,21,0,4.5%,2025-01-21,0.0
1331,Kalinka,880.2,32,5,27,0,15.6%,2025-04-26,0.0
1332,JLovelock,875.3,155,57,98,0,36.8%,2025-06-12,-5.9
1333,Frytka,874.7,76,21,55,0,27.6%,2025-06-13,-52.0
1334,SzyK,874.4,193,79,114,0,40.9%,2025-06-21,-62.2
1335,MateuszM,872.6,85,21,64,0,24.7%,2024-10-22,0.0
1336,TymD,870.7,38,7,31,0,18.4%,2025-02-09,0.0
1337,Asia123,870.6,85,22,63,0,25.9%,2024-09-05,0.0
1338,FranekST,870.0,101,31,70,0,30.7%,2025-05-22,0.0
1339,Stachu2137,869.5,48,11,37,0,22.9%,2025-03-01,0.0
1340,AlaS7,867.5,141,41,100,0,29.1%,2024-09-19,0.0
1341,Chlebinio,862.8,76,18,58,0,23.7%,2025-05-25,0.0
1342,Misio94,861.8,206,56,150,0,27.2%,2025-06-26,-59.8
1343,Mario333,858.3,55,12,43,0,21.8%,2025-06-21,-94.9
1344,AdaR28,857.8,38,5,33,0,13.2%,2025-06-19,-85.5
1345,MateuszMiotk,854.8,92,27,65,0,29.3%,2025-05-24,0.0
1346,BaduBidu,853.4,101,24,77,0,23.8%,2025-04-01,0.0
1347,Wolek,844.2,113,42,71,0,37.2%,2025-02-26,0.0
1348,DeathSpider,843.1,252,86,166,0,34.1%,2025-06-25,-84.8
1349,MatK21,841.9,56,14,42,0,25.0%,2025-03-16,0.0
1350,Shollow,834.3,222,65,157,0,29.3%,2025-06-30,-167.8
1351,Barotko,829.0,78,14,64,0,17.9%,2025-02-26,0.0
1352,Lzientak,812.4,44,7,37,0,15.9%,2025-06-28,-132.9
1353,StefanZalewski,808.9,48,9,39,0,18.8%,2025-05-15,0.0
1354,Domperignome,804.2,322,103,219,0,32.0%,2025-06-19,-222.2
1355,MarI8,799.1,38,4,34,0,10.5%,2025-03-07,0.0
1356,WikP,791.7,98,24,74,0,24.5%,2025-04-10,0.0
1357,madfuneral,789.6,86,20,66,0,23.3%,2025-06-28,-95.5
1358,Maxero0x,789.5,34,1,33,0,2.9%,2024-11-18,0.0
1359,HiczeQ,786.9,64,16,48,0,25.0%,2025-02-16,0.0
1360,Kavva,775.1,147,40,107,0,27.2%,2025-06-25,-98.4
1361,przck_depresja,772.4,253,66,187,0,26.1%,2025-06-29,+66.1
1362,hanahake,761.7,50,6,44,0,12.0%,2025-06-18,-27.2
1363,MiForrd,739.8,60,9,51,0,15.0%,2025-05-15,0.0
1364,FraF21,738.9,90,23,67,0,25.6%,2025-06-21,-101.0
1365,BloodC,735.6,46,3,43,0,6.5%,2024-10-30,0.0
1366,MacK2,703.2,96,21,75,0,21.9%,2025-05-28,0.0
1367,KatM35,692.6,44,2,42,0,4.5%,2025-06-26,-56.3
1368,RudalkaRudalia,631.5,78,13,65,0,16.7%,2025-04-13,0.0
1369,Repto,614.5,107,26,81,0,24.3%,2025-05-28,0.0
1370,Mariano,588.6,113,19,94,0,16.8%,2025-06-24,-68.7
1371,Krasnal1981CT,573.9,139,36,103,0,25.9%,2025-04-14,0.0
1372,Sanska,545.7,88,11,77,0,12.5%,2024-10-20,0.0
1373,Adeq,535.5,125,25,100,0,20.0%,2025-06-17,-111.8
`;

function EloRanking() {
    const [rankingData, setRankingData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [hideInactive, setHideInactive] = useState(false);
    const [loading, setLoading] = useState(true);
    const [adjustedRankingData, setAdjustedRankingData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'rank', direction: 'asc' });
    const theme = useTheme();

    useEffect(() => {
        // Parsowanie danych CSV
        const parseCSV = (csvText) => {
            const lines = csvText.trim().split('\n');
            const headers = lines[0].split(',');

            return lines.slice(1).map((line, index) => {
                const values = line.split(',');
                return {
                    rank: parseInt(values[0]),
                    player: values[1],
                    rating: parseFloat(values[2]),
                    gamesPlayed: parseInt(values[3]) || 0,
                    wins: parseInt(values[4]) || 0,
                    losses: parseInt(values[5]) || 0,
                    draws: parseInt(values[6]) || 0,
                    winRate: values[7] || '0%',
                    lastGameDate: values[8],
                    eloChange: values[9] || '0.0'
                };
            });
        };

        // Symulacja ładowania danych
        setTimeout(() => {
            const data = parseCSV(csvData);
            setRankingData(data);
            setFilteredData(data);
            setAdjustedRankingData(data);
            setLoading(false);
        }, 500);
    }, []);

    useEffect(() => {
        // Aktualizacja przeliczonego rankingu gdy zmienia się ukrywanie nieaktywnych
        if (hideInactive) {
            const adjusted = rankingData
                .filter(player => !isInactivePlayer(player.lastGameDate))
                .map((player, index) => ({
                    ...player,
                    displayRank: index + 1
                }));
            setAdjustedRankingData(adjusted);
        } else {
            setAdjustedRankingData(rankingData);
        }
    }, [hideInactive, rankingData]);

    useEffect(() => {
        // Użyj przeliczonego rankingu jako podstawy do filtrowania
        let filtered = adjustedRankingData;

        // Filtrowanie po wyszukiwaniu
        if (searchTerm.trim() !== '') {
            filtered = filtered.filter(player =>
                player.player.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Sortowanie danych
        filtered = sortData(filtered, sortConfig);

        setFilteredData(filtered);
    }, [searchTerm, adjustedRankingData, sortConfig]);

    const sortData = (data, config) => {
        return [...data].sort((a, b) => {
            let aValue, bValue;

            switch (config.key) {
                case 'rank':
                    aValue = a.displayRank || a.rank;
                    bValue = b.displayRank || b.rank;
                    break;
                case 'player':
                    aValue = a.player.toLowerCase();
                    bValue = b.player.toLowerCase();
                    break;
                case 'rating':
                    aValue = a.rating;
                    bValue = b.rating;
                    break;
                case 'gamesPlayed':
                    aValue = a.gamesPlayed;
                    bValue = b.gamesPlayed;
                    break;
                case 'winRate':
                    aValue = parseFloat(a.winRate.replace('%', ''));
                    bValue = parseFloat(b.winRate.replace('%', ''));
                    break;
                case 'eloChange':
                    aValue = parseFloat(a.eloChange);
                    bValue = parseFloat(b.eloChange);
                    break;
                case 'lastGameDate':
                    aValue = new Date(a.lastGameDate);
                    bValue = new Date(b.lastGameDate);
                    break;
                default:
                    aValue = a[config.key];
                    bValue = b[config.key];
            }

            if (aValue < bValue) {
                return config.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return config.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
    };

    const handleSort = (key) => {
        setSortConfig(prevConfig => ({
            key,
            direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <UnfoldMoreIcon sx={{ fontSize: 16, opacity: 0.5 }} />;
        }
        return sortConfig.direction === 'asc'
            ? <ArrowUpwardIcon sx={{ fontSize: 16 }} />
            : <ArrowDownwardIcon sx={{ fontSize: 16 }} />;
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleClearSearch = () => {
        setSearchTerm('');
    };

    const handleHideInactiveChange = (event) => {
        setHideInactive(event.target.checked);
    };

    const getRankColor = (displayRank) => {
        if (displayRank === 1) return '#FFD700'; // Złoty
        if (displayRank === 2) return '#C0C0C0'; // Srebrny
        if (displayRank === 3) return '#CD7F32'; // Brązowy
        if (displayRank <= 10) return '#4CAF50'; // Zielony
        if (displayRank <= 50) return '#2196F3'; // Niebieski
        if (displayRank <= 100) return '#FF9800'; // Pomarańczowy
        return '#757575'; // Szary
    };

    const getRatingColor = (rating) => {
        if (rating >= 1900) return '#FFD700';
        if (rating >= 1800) return '#FF6B6B';
        if (rating >= 1700) return '#4ECDC4';
        if (rating >= 1600) return '#45B7D1';
        if (rating >= 1500) return '#96CEB4';
        if (rating >= 1400) return '#FFEAA7';
        return '#DDA0DD';
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('pl-PL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const isInactivePlayer = (dateString) => {
        const lastGameDate = new Date(dateString);
        const cutoffDate = new Date('2025-06-30');
        cutoffDate.setMonth(cutoffDate.getMonth() - 1); // 30 dni wstecz od 30 czerwca
        return lastGameDate < cutoffDate;
    };

    const getEloChangeColor = (eloChange) => {
        const change = parseFloat(eloChange);
        if (change > 0) return '#4CAF50'; // Zielony dla wzrostu
        if (change < 0) return '#F44336'; // Czerwony dla spadku
        return '#757575'; // Szary dla braku zmiany
    };

    const formatEloChange = (eloChange) => {
        const change = parseFloat(eloChange);
        if (change > 0) return `+${change.toFixed(1)}`;
        if (change < 0) return `${change.toFixed(1)}`;
        return '0.0';
    };

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress size={60} />
                </Box>
            </Container>
        );
    }

    return (
        <>
            <Helmet>
                <title>Ranking ELO - playLorcana.pl</title>
                <meta name="description" content="Ranking ELO graczy Disney Lorcana - sprawdź swoje miejsce w rankingu i śledź postępy innych graczy" />
                <meta property="og:title" content="Ranking ELO - playLorcana.pl" />
                <meta property="og:description" content="Ranking ELO graczy Disney Lorcana - sprawdź swoje miejsce w rankingu" />
            </Helmet>

            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Fade in timeout={800}>
                    <Box>
                        {/* Header */}
                        <Box textAlign="center" mb={4}>
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    fontWeight: 700,
                                    fontFamily: "Futura",
                                    background: 'linear-gradient(135deg, #ffffff, #c4b5fd)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    mb: 2
                                }}
                            >
                                Ranking ELO
                            </Typography>
                            <Typography
                                variant="h6"
                                color="text.secondary"
                                sx={{ mb: 3 }}
                            >
                                Ranking wykorzystuje zmodyfikowany system ELO (K=36, D≈117.27) dostosowany do losowości gier karcianych (wzorowany na systemach ELO z MTG). Każda pojedyncza gra jest liczona osobno, więc w meczach Bo3 zaliczane są 2 lub 3 indywidualne gry, a w Bo2 dwie gry. System wykorzystuje dzienne zamrażanie ratingów, co oznacza że wszystkie gry danego dnia są obliczane na podstawie ratingu z początku dnia, eliminując manipulacje związane z kolejnością rozgrywek. Dane pochodzą wyłącznie z turniejów Core Constructed na melee.gg i są aktualne na dzień 30 czerwca 2025.
                            </Typography>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ mb: 3, fontStyle: 'italic' }}
                            >
                                💡 Kliknij na nagłówek kolumny, aby posortować dane. Kliknij ponownie, aby zmienić kierunek sortowania.
                            </Typography>

                            {/* Statystyki */}
                            <Box display="flex" justifyContent="center" gap={3} flexWrap="wrap" mb={4}>
                                <Chip
                                    icon={<EmojiEventsIcon />}
                                    label={`${rankingData.length} graczy`}
                                    sx={{
                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                        color: 'white',
                                        border: '1px solid rgba(76, 29, 149, 0.3)'
                                    }}
                                />
                                <Chip
                                    icon={<TrendingUpIcon />}
                                    label={`Średni rating: ${Math.round(rankingData.reduce((sum, player) => sum + player.rating, 0) / rankingData.length)}`}
                                    sx={{
                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                        color: 'white',
                                        border: '1px solid rgba(76, 29, 149, 0.3)'
                                    }}
                                />
                                <Chip
                                    icon={<EmojiEventsIcon />}
                                    label={`${Math.round(rankingData.reduce((sum, player) => sum + player.gamesPlayed, 0) / 2).toLocaleString()} gier`}
                                    sx={{
                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                        color: 'white',
                                        border: '1px solid rgba(76, 29, 149, 0.3)'
                                    }}
                                />
                                <Tooltip
                                    title="Gracz jest uznawany za nieaktywnego, jeśli nie rozegrał żadnego meczu w ciągu ostatniego miesiąca (30 dni). ELO takich graczy może być nieaktualne."
                                    placement="top"
                                >
                                    <Chip
                                        icon={<Box
                                            component="span"
                                            sx={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                backgroundColor: '#ff9800',
                                                display: 'inline-block'
                                            }}
                                        />}
                                        label={`${rankingData.filter(player => isInactivePlayer(player.lastGameDate)).length} nieaktywnych`}
                                        sx={{
                                            backgroundColor: 'rgba(255, 152, 0, 0.2)',
                                            color: 'white',
                                            border: '1px solid rgba(255, 152, 0, 0.3)',
                                            cursor: 'help'
                                        }}
                                    />
                                </Tooltip>
                            </Box>
                        </Box>

                        {/* Wyszukiwanie i filtry */}
                        <Box mb={3}>
                            <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
                                <TextField
                                    sx={{
                                        flexGrow: 1,
                                        minWidth: { xs: 200, sm: 250 },
                                        '& .MuiInputBase-input': {
                                            fontSize: { xs: '0.875rem', sm: '1rem' }
                                        }
                                    }}
                                    variant="outlined"
                                    placeholder="Wyszukaj gracza po nicku..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ color: 'text.secondary' }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: searchTerm && (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleClearSearch} size="small">
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                            borderRadius: '12px',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(76, 29, 149, 0.3)',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgba(76, 29, 149, 0.5)',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#c4b5fd',
                                            }
                                        }
                                    }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={hideInactive}
                                            onChange={handleHideInactiveChange}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#ff9800',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(255, 152, 0, 0.08)',
                                                    },
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#ff9800',
                                                },
                                            }}
                                        />
                                    }
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box
                                                sx={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#ff9800',
                                                    display: 'inline-block'
                                                }}
                                            />
                                            <Typography variant="body2" color="white">
                                                Ukryj nieaktywnych
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{ color: 'white' }}
                                />
                            </Box>
                        </Box>

                        {/* Tabela rankingowa */}
                        <Paper
                            elevation={0}
                            sx={{
                                backgroundColor: 'rgba(17, 24, 39, 0.8)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(76, 29, 149, 0.3)',
                                borderRadius: '16px',
                                overflow: 'hidden'
                            }}
                        >
                            <TableContainer sx={{
                                maxWidth: '100%',
                                overflowX: 'auto',
                                '& .MuiTable-root': {
                                    minWidth: 600
                                }
                            }}>
                                <Table sx={{
                                    tableLayout: 'fixed',
                                    '& .MuiTableCell-root': {
                                        padding: { xs: '8px 4px', sm: '12px 8px' },
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                    }
                                }}>
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: 'rgba(76, 29, 149, 0.1)' }}>
                                            <TableCell
                                                onClick={() => handleSort('rank')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '50px', sm: '60px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    #
                                                    {getSortIcon('rank')}
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('player')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    width: { xs: '120px', sm: '200px' },
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    Gracz
                                                    {getSortIcon('player')}
                                                    <Tooltip title="Pomarańczowa kropka oznacza gracza nieaktywnego (brak meczów w ciągu ostatniego miesiąca)">
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                ml: 0.5,
                                                                width: 6,
                                                                height: 6,
                                                                borderRadius: '50%',
                                                                backgroundColor: '#ff9800',
                                                                display: 'inline-block'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('rating')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '80px', sm: '90px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    Rating
                                                    {getSortIcon('rating')}
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('gamesPlayed')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '60px', sm: '80px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    Gry
                                                    {getSortIcon('gamesPlayed')}
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('winRate')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '70px', sm: '80px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    Winrate
                                                    {getSortIcon('winRate')}
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('eloChange')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '80px', sm: '90px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    ELO (30d)
                                                    {getSortIcon('eloChange')}
                                                </Box>
                                            </TableCell>
                                            <TableCell
                                                onClick={() => handleSort('lastGameDate')}
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    borderBottom: '1px solid rgba(76, 29, 149, 0.3)',
                                                    textAlign: 'center',
                                                    width: { xs: '80px', sm: '100px' },
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.2)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                                    Ostatnia gra
                                                    {getSortIcon('lastGameDate')}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredData.map((player) => (
                                            <TableRow
                                                key={player.rank}
                                                sx={{
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(76, 29, 149, 0.1)',
                                                        transition: 'background-color 0.2s ease'
                                                    }
                                                }}
                                            >
                                                <TableCell
                                                    sx={{
                                                        color: getRankColor(player.displayRank || player.rank),
                                                        fontWeight: 600,
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)'
                                                    }}
                                                >
                                                    {player.displayRank || player.rank}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: 'white',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        maxWidth: { xs: '120px', sm: '200px' },
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    <Tooltip title={player.player} placement="top">
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography
                                                                sx={{
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                                }}
                                                            >
                                                                {player.player}
                                                            </Typography>
                                                            {isInactivePlayer(player.lastGameDate) && (
                                                                <Tooltip title="Gracz nie rozegrał meczu w ciągu ostatniego miesiąca - ELO może być nieaktualne">
                                                                    <Box
                                                                        sx={{
                                                                            width: 8,
                                                                            height: 8,
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#ff9800',
                                                                            animation: 'pulse 2s ease-in-out infinite',
                                                                            flexShrink: 0
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: getRatingColor(player.rating),
                                                        fontWeight: 600,
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}
                                                >
                                                    {player.rating.toFixed(1)}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: 'text.secondary',
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}
                                                >
                                                    {player.gamesPlayed}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: 'text.secondary',
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}
                                                >
                                                    {player.winRate}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: getEloChangeColor(player.eloChange),
                                                        fontWeight: 600,
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}
                                                >
                                                    {formatEloChange(player.eloChange)}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        color: 'text.secondary',
                                                        textAlign: 'center',
                                                        borderBottom: '1px solid rgba(76, 29, 149, 0.1)',
                                                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                                    }}
                                                >
                                                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                                        {formatDate(player.lastGameDate)}
                                                    </Box>
                                                    <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                                                        {new Date(player.lastGameDate).toLocaleDateString('pl-PL', {
                                                            month: '2-digit',
                                                            day: '2-digit'
                                                        })}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>

                        {/* Informacja o wynikach wyszukiwania */}
                        {searchTerm && (
                            <Box mt={2} textAlign="center">
                                <Typography variant="body2" color="text.secondary">
                                    Znaleziono {filteredData.length} wyników dla "{searchTerm}"
                                </Typography>
                            </Box>
                        )}

                        {/* Informacja o nieaktywnych graczach */}
                        <Box mt={3} textAlign="center">
                            <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                <Box
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        backgroundColor: '#ff9800',
                                        display: 'inline-block'
                                    }}
                                />
                                Pomarańczowa kropka oznacza gracza nieaktywnego (brak meczów w ciągu ostatniego miesiąca) - ELO może być nieaktualne
                            </Typography>
                        </Box>
                    </Box>
                </Fade>
            </Container>
        </>
    );
}

export default EloRanking; 